//import Cookies from './cookies'

import ApiRequests from "./apiRequests";
import DpdSlots from "./dpdSlots";
import KissSlots from "./kissSlots";
import TvSlots from "./tvSlots";

//import Validator from './validator'
import AutoComplete from "./autoComplete";

import "../librarys/jquery-ui-1.12.1.custom/jquery-ui.min.js";
//import datePicker from './datePicker';

import Handlebars from "hbs";

import ConfigData from "../../copy/uk/repair-form-config.json";

//import SymptomsData from '../symptoms.json';

// ==================
// Templates
// ==================
import ProductTypeOptions from "../../templates/components/booking-form/productTypeOptions.html";
import ProductConditions from "../../templates/components/booking-form/productCondition.html";

import BookingSuccess from "../../templates/components/booking-form/bookingSuccess.html";
import BookingSuccessKiss from "../../templates/components/booking-form/bookingSuccessKiss.html";
import BookingFail from "../../templates/components/booking-form/bookingFail.html";
import BookingFailKiss from "../../templates/components/booking-form/bookingFailKiss.html";
import FailNoCaseId from "../../templates/components/booking-form/failNoCaseId.html";
import TooManyAttempts from "../../templates/components/booking-form/tooManyAttempts.html";
import FailCaseIdUsed from "../../templates/components/booking-form/failCaseIdUsed.html";
import FailAscNotFound from "../../templates/components/booking-form/failAscNotFound.html";
import FailPendingTicketExists from "../../templates/components/booking-form/failPendingTicketExists.html";
import FailRepeatRepairWithin90days from "../../templates/components/booking-form/failRepeatRepairWithin90days.html";
import FailSRPendingTicketExists from "../../templates/components/booking-form/failSRPendingTicketExists.html";
import FailFieldLengthLonger from "../../templates/components/booking-form/failFieldLengthLonger.html";

import FailBespokeNotAFlipSku from "../../templates/components/booking-form/failBespokeNotAFlipSku.html";
import ConfirmYourBooking from "../../templates/components/booking-form/confim-your-booking.html";
import confirmYourBookingKiss from "../../templates/components/booking-form/confirm-your-booking-kiss-da.html";
import ConfirmYourBookingKissTvAv from  "../../templates/components/booking-form/confirm-your-booking-kiss-tvav.html";
import Thankyouuk from "../../templates/components/booking-form/thankyou.html";
import Thankyouie from "../../templates/components/booking-form/thankyouie.html";
import Thankyoukiss from "../../templates/components/booking-form/thankyoukiss.html";

//import Symptoms from '../../templates/components/symptoms.html';

export default class HomeRepair extends ApiRequests {
  /* Constructor */
  constructor() {
    super();
    this.TAG = "repairbooking";
    this.templates = {};
    this.defaultCat = "mobile";
    this.lucidRef = "";

    this.templates.productTypeOptions = ProductTypeOptions;
    this.templates.productConditions = ProductConditions;

    this.templates.bookingSuccess = BookingSuccess;
    this.templates.bookingSuccessKiss = BookingSuccessKiss;
    this.templates.bookingfail = BookingFail;

    this.templates.fail400 = FailNoCaseId;
    this.templates.fail403 = TooManyAttempts;
    this.templates.fail401 = FailCaseIdUsed;
    this.templates.fail458 = FailAscNotFound;
    this.templates.fail478 = FailPendingTicketExists;
    this.templates.failsr478 = FailSRPendingTicketExists;
    this.templates.fail902 = FailFieldLengthLonger;
    this.templates.failRepeatRepairReq = FailRepeatRepairWithin90days;
    this.templates.failBespokeNotAFlipSku = FailBespokeNotAFlipSku;
    this.templates.confirmYourBooking = ConfirmYourBooking;
    this.templates.confirmYourBookingKiss = confirmYourBookingKiss;
    this.templates.confirmYourBookingTvAv = ConfirmYourBookingKissTvAv;

    if (site == "ie") {
      this.templates.thankyou = Thankyouie;
    } else if (site == "uk") {
      this.templates.thankyou = Thankyouuk;
    }
    this.templates.thankyoukiss = Thankyoukiss;

    // this.templates.symptoms = Symptoms;
    this.address = new Object();
    this.contactDetails = new Object();
    this.deviceDetails = new Object();

    //$('.repair-booking').hide();
    this.getLucidTSOutcome();
    this.defaultProductIssue = "";

    //alert(this.maintenanceData().show_maintenance_message);

    $(".maintenance").hide();
    if (window.state.ismaintenanceflagon) {
      $("#repair-request-form .maintenance").show();
      $("#repair-request-form .repair-booking").hide();
    } else if (this.tsRef != "") {
      this.setConfigData();
      this.init();
      this.events();
      $(".device-details.steps").show();
    } else {
      $("#repair-request-form .repair-booking").hide();
      $(".no-lucid-ref.steps").show();
    }

    //this.scrollTo('#repair-booking-form', 400);
    //$('.maintenance').show();
  }

  init() {
    this.callId = null;

    this.host = window.state.apihost;

    this.step = "step0";
    this.initStep0();

    this.path = "/uk/repair-booking/";

    this.postcodeSearch = true;
    this.validatedPostCode = "";
    this.isValidPostCode = false;
    this.isRequestToPdListSent = false;

    this.gaId =
      location.host == "qaweb.samsung.com"
        ? "UA-101298876-1"
        : "UA-100137701-12";

    /** Reset the form if it have previous details**/
    this.resetForm($("#warranty-details"));
    this.resetForm($("#device-fault"));
    this.resetForm($("#contact-details"));

    /** In the form device collection option not shown to user if it is not in-store repair,
        only lockers selected as instore repair service then show the pickup option lockers other
        wise remove it from dropdown **/

    if (window.state.selectedservice != "ISR") {
      $(".device-pickup-options-row").hide();
    } else {
      $(".device-pickup-options-row").show();
      $(".collection-opt .radio").show();
      //$('.lockers-only-pickup-row').hide();
      $("#device-pickup-option").val("");

      // For store's not having locker facility hide locker collection option
      /*if (window.state.islockersavailable != true) {

                $('.collection-opt .radio[data-value="Collection Locker"]').hide();

            }*/
    }

    /** Generate new recaptcha for a new request **/
    //this.updateRecaptchaResponse('contact', 'recaptchaResponse');

    /** show the disclaimer only the check box clicked  **/
    $("#steps1-disclaimer").hide();
  }

  setConfigData() {
    var data = this.data();

    var category = this.category;

    this.formConfigData = {};
    this.deviceDetails.parentCagegory = "";

    // $(".product-cats .product-cat").css('opacity', '0.6');

    switch (category) {
      case "homeappliance":
        this.formConfigData = data.homeappliance[0];
        // $(".product-cats .product-cat.homeappliance").css('opacity', '1');
        this.deviceDetails.parentCagegory = "homeappliance";
        window.state.howDoIFindFaqHash = "#homeappliances";
        break;
      case "tvav":
        this.formConfigData = data.tvav[0];
        // $(".product-cats .product-cat.tv-av").css('opacity', '1');
        this.deviceDetails.parentCagegory = "tvav";
        window.state.howDoIFindFaqHash = "#tvaudiovideo";
        break;
      case "itrepair":
        this.formConfigData = data.monitoroffice[0];
        // $(".product-cats .product-cat.monitor-office").css('opacity', '1');
        this.deviceDetails.parentCagegory = "monitoroffice";
        window.state.howDoIFindFaqHash = "#informationtechnology";
        break;
      case "mobile":
      default:
        this.formConfigData = data.mobile[0];
        // console.log(this.formConfigData, data.mobile[0])
        //$(".product-cats .product-cat.mobile").css('opacity', '1');
        this.deviceDetails.parentCagegory = "mobile";
        window.state.howDoIFindFaqHash = "#mobiledevices";
        break;
    }

    this.customiseForm();

    // IE chan
    if (site == "ie") {
      $(".contact-details .autocomplete-items").remove();
      //$this.customSelector.reset('#address');
      $("#address1").removeAttr("disabled");
      $("#address2").removeAttr("disabled");
      $("#address3").removeAttr("disabled");
      $("#town").removeAttr("disabled");
    }
  }

  customiseForm() {
    var headerText = this.formConfigData.header_text;
    var productTypes = this.formConfigData.product_types;
    var productPurchaseText = this.formConfigData.product_purchase_date_text;
    // var isImeiNumberRequired = this.formConfigData.imei_no_element_req;
    // var isSerialNoRequired = this.formConfigData.serial_no_required;
    //var dopStartDate = this.formConfigData.date_of_pruchase_eligible_start_date;
    //var warrantyConfirmText3 = this.formConfigData.warranty_confirm_text_3;
    var productConditions = this.formConfigData.product_conditions;
    var addressLabel = this.formConfigData.address_label;
    var step3Disclaimer = this.formConfigData.step3_disclaimer;

    $("#header-text").html(headerText);
    this.drawProductTypeOptions(productTypes);
    $("#product-purchase-text").html(productPurchaseText);
    //$('#warranty-confirm-text3').html(warrantyConfirmText3);
    this.drawProductCondition(productConditions);

    if (window.state.selectedservice == "ISR") {
      $("#address-label").html("Customer address");
    } else if (window.state.selectedservice == "KISS" || window.state._product == "AV" || window.state._product == "TV") {
      $("#address-label").html("Your address");
    } else {
      $("#address-label").html(addressLabel);
    }

    //        $('.step3-disclaimer').html(step3Disclaimer);

    //$('.repair-booking').show();

    this.showStep0();

    /*   this.lucidRef = '97-58819109';
        this.soCreateResponse = {};
        this.soCreateResponse.success = false;
        this.soCreateResponse.bodyCode = "478";
        this.showStep4();*/

    /*var isValidationRuleUpdated = this.updateValidationRulesAndPlaceHolders(productTypes[0]);

        if (isValidationRuleUpdated) {

            $('.repair-booking').show();

            this.showStep0();

        }*/
  }

  drawProductTypeOptions(productTypes) {
    if (window.state.product != "") {
      if (window.state.product == "Cooking") {
        productTypes = this.formConfigData.product_types_cooking;
      }
    }

    var source = this.templates.productTypeOptions;
    var template = Handlebars.compile(source);
    var compiled = template({
      productTypes: productTypes,
    });

    $("#product-type").html(compiled);

    if (window.state.product != "") {
      if (window.state.product != "Cooking") {
        var isValidationRuleUpdated = this.updateValidationRulesAndPlaceHolders(
          window.state.product
        );
        $("#product-type").val(window.state.product);
        $("#product-type").trigger("change");
        $("#product-type-row").hide();
      } else if (
        window.state.saProductDetail.length &&
        window.state.saProductDetail[0].deviceTypeCode != "undefined"
      ) {
        var isValidationRuleUpdated = this.updateValidationRulesAndPlaceHolders(
          window.state.saProductDetail[0].deviceTypeCode
        );
        $("#product-type").val(window.state.saProductDetail[0].deviceTypeCode);
        $("#product-type").trigger("change");
        $("#product-type-row").hide();
      } else {
        $("#product-type-row").show();
      }
    }

    /*if (productTypes.length == 1) {

            $("#product-type").val(productTypes[0]);

        }*/
  }

  drawProductCondition(productConditions) {
    var template = Handlebars.compile(ProductConditions);
    var compiled = template({
      productConditions: productConditions,
    });

    $("#product-condition").val("");
    $("#device-issues").html(compiled);

    $("#device-issues .radio").on("click", function (e) {
      $("#device-issues .radio").removeClass("active");
      $(this).addClass("active");
      var selectedDeviceIssue = $(this).attr("data-device-issue");
      $("#product-condition").val(selectedDeviceIssue);
      $("#product-condition").trigger("change");
    });
  }

  updateValidationRulesAndPlaceHolders(selectedProductType) {
    var productTypeKey = selectedProductType.replace(" ", "_").toLowerCase();
    //console.log('Porduct type key', productTypeKey);
    //console.log(this.formConfigData);
    var rulesAndPlaceHolders =
      this.formConfigData.rules_and_placeholders[productTypeKey];
    var modelPlaceHolder = rulesAndPlaceHolders["model_place_holder_text"];
    var serialPlaceHolder = rulesAndPlaceHolders["serial_no_place_holder_text"];

    this.modelCharLength = rulesAndPlaceHolders["model_no_of_chars"];
    this.serialCharLength = rulesAndPlaceHolders["serial_no_of_chars"];
    $("#model").attr("placeholder", modelPlaceHolder);
    $("#serial").attr("placeholder", serialPlaceHolder);

    //this.validate();

    /** To make sure already entered values satisfy the new validation rules **/

    if ($("#model").val() != "") {
      $("#model").trigger("input");
    }

    if ($("#serial").val() != "") {
      $("#serial").trigger("input");
    }

    return true;
  }

  getLucidTSOutcome() {
    //var cookiests = new Cookies();
    //this.cookiests = cookiests;

    var tsOutcome = window.state.tsoutcome;

    this.category = window.state.category;

    //console.log(tsOutcome);
    //console.log(this.category);

    //console.log(tsOutcome.length);

    if (tsOutcome != undefined && $.type(tsOutcome) === "object") {
      var tsRef = tsOutcome["tsSessionRef"];
      var lucidRef = tsOutcome["lucidRef"];
      var symptoms1 = tsOutcome["symptomCode1"];
      var symptoms2 = tsOutcome["symptomCode2"];
      var symptoms3 = tsOutcome["symptomCode3"];
      var wtyEx = tsOutcome["warrantyException"];
      var selectedIssue = tsOutcome["selectedIssue"];

      this.lucidRef = lucidRef == undefined || lucidRef == "" ? "" : lucidRef;
      //this.lucidRef = (cookieLR == undefined || cookieLR == "") ? lucidRef : cookieLR;
      this.symptoms1 =
        symptoms1 == undefined || symptoms1 == "" ? 99 : symptoms1;
      this.symptoms2 =
        symptoms2 == undefined || symptoms2 == "" ? 99 : symptoms2;
      this.symptoms3 =
        symptoms3 == undefined || symptoms3 == "" ? 99 : symptoms3;
      this.wtyException = wtyEx == undefined ? "" : wtyEx;
      this.selectedIssue = selectedIssue == undefined ? "" : selectedIssue;

      //console.log(tsRef);

      this.tsRef = tsRef == "" ? "" : tsRef;

      //console.log(this.tsRef);

      this.doLog("Lucid Ref = " + this.lucidRef);
    }
  }

  data() {
    return ConfigData;
  }

  symptoms() {
    return SymptomsData.symptoms;
  }

  events() {
    var $this = this;

    $("#repair-request-form .step0 #pd-info-submit .btn.next")
      .off("click")
      .on("click", function () {
        $(".lds-ring").show();
        $(".step0 #pd-info-submit .btn.next").attr("disabled", true);
        $this.updateRecaptchaResponse("contact", "recaptchaResponse");
        //$this.checkWarranty();
      });

    $("#repair-request-form .step0 #kiss-booking-details .btn.next")
      .off("click")
      .on("click", function () {
        $this.getDeviceDetails();
      });

    $("#repair-request-form .step0 #warranty-details .btn.next")
      .off("click")
      .on("click", function () {
        $this.getDeviceDetails();
      });

    $("#repair-request-form .step0 .how-do-i-find-model-and-serial")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        var faqLink = $(this).attr("href") + window.state.howDoIFindFaqHash;
        window.open(faqLink, "_blank");
      });

    /*$('.step1 .btn.next').on('click', function() {

            $this.getDeviceDetails()

        });*/

    $("#repair-request-form .step2 .btn.next")
      .off("click")
      .on("click", function () {
        $this.getDeviceIssues();
      });

    $("#repair-request-form .step21 .btn.next")
      .off("click")
      .on("click", function () {
        $this.getDpdCollectionDate();
      });

    $("#repair-request-form .step21kiss .btn.next")
      .off("click")
      .on("click", function () {
        $this.getAppointmentDate();
      });

    $("#repair-request-form .step21tv .btn.next")
      .off("click")
      .on("click", function () {
        $this.getAppointmentDate();
      });

    // To add Troubleshooter ref to the Customer comment field
    $("#repair-request-form .step2 #issue-needs-to-fix")
      .off("click")
      .on("click", function () {
        if (
          // $this.lucidRef != "" &&
          // typeof $this.lucidRef !== "undefined" &&
          window.state._tsRef != "" &&
          $(this).val() == ""
        ) {
          var tsRef = $this.lucidRef ? $this.lucidRef : window.state._tsRef;

          var defaultValue =
            "Troubleshooter reference number: " + tsRef;

          defaultValue += window.state.saProductDetail.length > 0 ? "-MP" : "";

          defaultValue = defaultValue + "\n";

          $this.defaultProductIssue = defaultValue;
          // This validation is for customer not to delete default populated text with lucid ref
          $this.regexDefaultCustomerComment = new RegExp(
            "^" + defaultValue,
            "i"
          );

          $(this).val(defaultValue);
          $(this).attr("oldvalue", defaultValue);
        }
      });

    $("#repair-request-form .step2 #issue-needs-to-fix").keyup(function () {
      // Setting this to compare the user enter value to populated value
      $(this).attr("oldvalue", $(this).val());

      var characterCount = $(this).val().length,
        current = $("#repair-request-form .step2 #current"),
        maximum = $("#repair-request-form .step2 #maximum"),
        theCount = $("#repair-request-form .step2 #the-count"),
        maxchartext = $("#repair-request-form .step2 #max-char-text"),
        maxlimit = 800;

      current.text(characterCount);

      if (characterCount >= 650) {
        maximum.css("color", "#ff001f");
        current.css("color", "#ff001f");
        maxchartext.css("color", "#ff001f");
        maxchartext.css("font-weight", "bold");
        theCount.css("font-weight", "bold");
      } else {
        maximum.css("color", "#000");
        current.css("color", "#000");
        maxchartext.css("color", "#000");
        maxchartext.css("font-weight", "normal");
        theCount.css("font-weight", "normal");
      }

      if (characterCount > maxlimit) {
        $(this).val($(this).val().substring(0, maxlimit));
        return false;
      }
    });

    $("#repair-request-form .step3 .btn.next")
      .off("click")
      .on("click", function () {
        $this.changeCalendarText();
        $this.getContactDetails();
      });

    $("#repair-request-form .step31 .btn.next")
      .off("click")
      .on("click", function () {
        /** Disable the button once clicked **/
        $("#repair-request-form .step31 .btn.next").removeClass("blue");
        $("#repair-request-form .step31 .btn.next").attr("disabled", true);
        $(".lds-ring").show();

        // $this.soCreateResponse = {
        //   tsdetails: [
        //     {
        //       lucidRef: "97-148026168",
        //       symptomCode1: 99,
        //       symptomCode2: 99,
        //       symptomCode3: 99,
        //       warrantyException: "",
        //     },
        //   ],
        //   serialnumber: "4GDM39FN900069Z",
        //   success: true,
        //   headerCode: "200",
        //   headerCodeDesc: "Success",
        //   bodyCode: "200",
        //   bodyCodeDesc: "Success",
        //   caseId: "97-148026168",
        //   serviceOrderNo: "4110318996",
        //   serviceRequestNo: "4110318996",
        // };
        // $this.showStep4();
        $this.doRepairBooking();
      });

    $("#repair-request-form .step3 .collection-opt .radio")
      .off("click")
      .on("click", function () {
        $(this).parent().find(".radio").removeClass("selected");
        $(this).addClass("selected");
        var val = $(this).attr("data-value");
        $(this).parent().find("input").val(val);
        $(this).parent().find("input").trigger("input");
      });

    $("#postcodesearch")
      .off("input")
      .on("input", function () {
        var postcodeValue = $.trim(this.value);

        $("#postcode").val("");
        $(".contact-details .autocomplete-items").remove();

        if (postcodeValue == "" || postcodeValue.length < 5) {
          $("#postcode").trigger("input");
        } else {
          $this.validatePostcode(postcodeValue);
        }
      });

    $(".address-option")
      .off("click")
      .on("click", function () {
        $("#address1").val("");
        $("#address2").val("");
        $("#address3").val("");
        $("#town").val("");
        // $('#country').val("")
        $("#postcode").val("");
        $("#postcodesearch").val("");
        window.state.validatedpostcode = "";
        window.state.isvalidpostcode = false;
        this.validatedPostCode = "";
        this.isValidPostCode = false;

        //$this.validate("step3");
        $("#postcode").trigger("input");
        $("#address1").trigger("input");
        $("#town").trigger("input");
        //$('#country').trigger('input');

        if (site == "uk") {
          if ($(this).hasClass("manual")) {
            $(".address-option.manual").hide();
            $(".address-option.search").show();

            $("#postcode").show();
            $("#postcodesearch").hide();

            $(".lds-ring").hide();

            $(".contact-details .autocomplete-items").remove();
            //$this.customSelector.reset('#address');
            $("#address1").removeAttr("disabled");
            $("#address2").removeAttr("disabled");
            $("#address3").removeAttr("disabled");
            $("#town").removeAttr("disabled");
            //$('#country').removeAttr("disabled");

            $this.postcodeSearch = false;
          } else {
            $(".address-option.manual").show();
            $(".address-option.search").hide();

            $("#postcode").hide();
            $("#postcodesearch").show();
            $("#address1").attr("disabled", "disabled");
            $("#address2").attr("disabled", "disabled");
            $("#address3").attr("disabled", "disabled");
            $("#town").attr("disabled", "disabled");
            // $('#country').attr("disabled", "disabled");

            $this.postcodeSearch = true;
          }
        }
      });

    //** POP EVENT REMOVE **/
    $(".pop-image-file__label-message").off("click")
    .on("click",".pop__success-message-remove", function (e) {
      e.preventDefault()
      $this.proofOfPurchaseReset()
    })

    /** Address selected from auto select dropdown **/

    $(".custom-select #address")
      .off("change")
      .on("change", function () {
        var selAddressId = $(".custom-select #address").val();

        if (selAddressId != "") {
          $this.getAddressDetail(selAddressId);
        }
      });

    $("#repair-request-form .button.back")
      .off("click")
      .on("click", function () {
        $this.stepBack();
        //$this.validate();
      });
  }

  getContactDetails() {
    var $this = this;
    $this.contactDetails.firstName = $.trim($("#firstname").val());
    $this.contactDetails.lastName = $.trim($("#lastname").val());
    $this.contactDetails.email = $.trim($("#email").val());
    $this.contactDetails.address1 = $.trim($("#address1").val());
    $this.contactDetails.address2 = $.trim($("#address2").val());
    $this.contactDetails.address3 = $.trim($("#address3").val());

    var phoneNumber = $.trim($("#phonenumber").val());

    // IE change
    if (site == "uk") {
      var pnIntFormat = phoneNumber.replace("0", "+44 ");
      $this.contactDetails.town = $.trim($("#town").val());
      $this.contactDetails.postcode = $.trim($("#postcode").val());
    } else if (site == "ie") {
      var pnIntFormat = phoneNumber.replace("0", "+353 ");
      $this.contactDetails.town = $.trim($("#county").val());
      var eircode = $.trim($("#eircode").val());
      // If eircode empty pass post code value as empty instead of , because its not working for Tv-av
      $this.contactDetails.postcode = eircode != "" ? eircode : "";
    }

    $this.contactDetails.phone = pnIntFormat;

    $this.contactDetails.country = $.trim($("#country").val());
    $this.contactDetails.countryCode = $this.getCountryCodeByCountry(
      $this.contactDetails.country
    );

    if (window.state.selectedservice == "ISR") {
      if (
        window.state.islockersavailable != true ||
        window.state.selectedisrservice == "in-store"
      ) {
        $this.contactDetails.devicePickupOption =
          "Drop Off 121 / " + $.trim($("#device-pickup-option").val());
      } else {
        $this.contactDetails.devicePickupOption =
          "Drop Off Locker / " + $.trim($("#device-pickup-option").val());
      }
    }

    var contactby = [];
    $this.contactDetails.contactbyEmail = "";
    $this.contactDetails.contactbyPhone = "";
    $this.contactDetails.contactbySMS = "";

    // $this.contactDetails.recaptchaResponse = $.trim($('#recaptchaResponse').val());

    $.each($("input[name='contact']:checked"), function () {
      contactby.push($(this).val());

      if ($(this).val() == "Email") {
        $this.contactDetails.contactbyEmail = 2;
      } else if ($(this).val() == "Phone") {
        $this.contactDetails.contactbyPhone = 2;
      } else if ($(this).val() == "SMS") {
        $this.contactDetails.contactbySMS = 2;
      }
    });

    $this.contactDetails.contact = contactby.join();

    
    // temp calendar view FLS
    if (
      window.state._selectedservice === 'IHTVDA' && window.state._availableservice === 'IHTVDA' ||
      window.state._selectedservice === 'PSTVDA' && window.state._availableservice === 'PSTVDA'
    ) {
      $this.showStep21Tv();
    } else {
      $this.showStep31();
    }
  }

  getCountryCodeByCountry(country) {
    var countryCode = "";

    switch (country) {
      case "Ireland":
        countryCode = "IE";
        break;

      case "United Kingdom":
      default:
        countryCode = "GB";
        break;
    }

    return countryCode;
  }

  getDeviceDetails() {
    var $this = this;
    $this.deviceDetails.productType = $.trim($("#product-type").val());
    $this.deviceDetails.model = $.trim($("#model").val());
    $this.deviceDetails.serial = $.trim($("#serial").val());
    $this.deviceDetails.imeiNumber = $.trim($("#imei-number").val());

    if (window.state.selectedservice == "KISS") {
      $this.deviceDetails.dateOfPurchase = $.trim($("#date-of-purchase").val());
      $this.deviceDetails.placeOfPurchaseText = $.trim(
        $("#place-of-purchase").val()
      );
      $this.deviceDetails.placeOfPurchase = $("#place-of-purchase")
        .find(":selected")
        .data("pp");
    } else {
      $this.deviceDetails.dateOfPurchase = "";
      $this.deviceDetails.placeOfPurchase = "";
      $this.deviceDetails.placeOfPurchaseText = "";
    }

    /** Date of purchase removed **/
    /*if (!$this.isProductInWarranty) {

            $this.deviceDetails.dateOfPurchase = $.trim($('#dateofpurchase').val());

            //$this.deviceDetails.dateOfPurchase = "";

        }*/

    $this.showStep2();
  }

  getDeviceIssues() {
    var $this = this;
    $this.deviceDetails.productCondition = $.trim(
      $("#product-condition").val()
    );
    $this.deviceDetails.issueNeedToFix = $.trim($("#issue-needs-to-fix").val());
    $this.deviceDetails.symptoms1 = $this.symptoms1;
    $this.deviceDetails.symptoms2 = $this.symptoms2;
    $this.deviceDetails.symptoms3 = $this.symptoms3;
    $this.deviceDetails.wtyException =
      $this.getWtyExceptionByProductCondition();
    $this.deviceDetails.lucidRef = $this.lucidRef;
    $this.deviceDetails.tsRef = $this.tsRef;
    $this.deviceDetails.selectedIssue = $this.selectedIssue;
    $this.deviceDetails.collectionDate = "";

    /** only for pickup service show the Dpd slots for users to pick **/
    if (window.state.selectedservice == "KISS") {
      $this.showStep21Kiss();
    } 
    // else if (window.state.product == "TV" || window.state.product == "AV") {
    //   $this.showStep21Tv();
    // } 
    else if (
      (window.state.selectedservice == "PS" ||
        window.state.selectedservice == "BESPOKE") &&
      site == "uk"
    ) {
      $this.showStep21();
    } else {
      $this.showStep3();
    }
  }

  getDpdCollectionDate() {
    var $this = this;
    $this.deviceDetails.collectionDate = $.trim(
      $("#device-collection-date").val()
    );
    $this.showStep3();
  }

  getAppointmentDate() {
    var $this = this;

    const removenth = function (d) {
      return d
        .replace("th", "")
        .replace("st", "")
        .replace("nd", "")
        .replace("rd", "");
    };

    const dateformater = function (dateObj) {
      const month =
        dateObj.getMonth() + 1 >= 10
          ? dateObj.getMonth() + 1
          : "0" + (dateObj.getMonth() + 1);
      const date =
        dateObj.getDate() >= 10 ? dateObj.getDate() : "0" + dateObj.getDate();
      const formatedDate = dateObj.getFullYear() + "" + month + "" + date;
      return formatedDate;
    };

    var appointmnetDate = $.trim($("#selected-appointment-date").val());
    var selectedSlot = $.trim($("#selected-appointment-time").val());
    var appointmentTime =
      selectedSlot == "AM" || selectedSlot == "Book now" ? "090000" : "130000";
    $this.deviceDetails.appointmentDate = appointmnetDate;
    $this.deviceDetails.appointmentTime = appointmentTime;
    window.state.timeBooked = selectedSlot;
    // console.log(appointmnetDate);
    // console.log(appointmentTime);

    if (
      window.state._selectedservice === 'IHTVDA' && window.state._availableservice === 'IHTVDA' ||
      window.state._selectedservice === 'PSTVDA' && window.state._availableservice === 'PSTVDA'
    ) {
      $this.showStep31();
    } else {
      $this.showStep3();
    }
    
  }

  getWtyExceptionByProductCondition() {

    var $this = this;
    var productCondition = $this.deviceDetails.productCondition;
    var wtyExceptionProdConds = ["Physically Damaged", "Yes"];

    /** wtyException value from troubleshooter already set in this variable from cookie **/
    if ($this.wtyException == "" || $this.wtyException == undefined) {
      if (wtyExceptionProdConds.indexOf(productCondition) > -1) {
        $this.wtyException = "VOID1";
      }
    }

    return $this.wtyException;
  }

  initStep0() {
    var $this = this;
    $(".container .steps").hide();
    $this.resetForm($("#device-fault"));
    $this.resetForm($("#kiss-booking-details"));
    $this.resetForm($("#warranty-details"));
    $(".container .steps.step0").show();

    $this.hideBtnElement("#warranty-details .btn.next");
    $this.hideBtnElement("#kiss-booking-details .btn.next");
    $this.hideBtnElement("#repair-request-form .step2 .btn.next");
    $("#device-issues .radio").removeClass("active");

    $this.hidWarranty();
    $this.step = "step0";
    window.supportComponents.steps.setActiveStep(3);

    // ******************* REMOVE COMMENT FOR POP (DO NOT REMOVE YET) **************************************** //
    if (window.state.category == 'mobile' && window.state.selectedservice == 'PS' && window.state._popJourney.length >= 1) {
      $(".container .steps.step0 #proof-of-purchase").show()
      $this.proofOfPurchase()
    } else if (window.state.category == 'homeappliance' && window.state.selectedservice == 'KISS' && window.state._popJourney.length >= 1) {
      $(".container .steps.step0 #proof-of-purchase__DA").show()
      $this.proofOfPurchase()
    } else {
      $(".container .steps.step0 #proof-of-purchase__DA").hide()
      $(".container .steps.step0 #proof-of-purchase").hide()
    }

    // ******************* REMOVE COMMENT FOR POP (DO NOT REMOVE YET) **************************************** //

    // ******************* REMOVE THIS FOR POP ******************************* //
    // $(".container .steps.step0 #proof-of-purchase__DA").hide()
    // $(".container .steps.step0 #proof-of-purchase").hide()
    // ******************* REMOVE THIS FOR POP ******************************* //

    // $this.updateRecaptchaResponse('contact', 'recaptchaResponse');

    $this.changeTimeLine("Battery Replacement");
  }

  stepBack() {
    var $this = this;
    $this.scrollTo("#repair-booking-form");
    $(".container .steps").hide();

    if ($this.step == "step2") {
      $("#product-condition").val("");
      $this.proofOfPurchaseReset()
      this.initStep0();
    } else if ($this.step == "step21") {
      $("#repair-request-form .step21 .collection-slots .slot").removeClass(
        "selected"
      );
      $this.hideBtnElement("#repair-request-form .step21 .btn.next");
      $("#device-collection-date").val("");
      $(".container .steps.step2").show();
      $this.step = "step2";
    } else if ($this.step == "step21kiss" || $this.step == "step21tv") {
      $this.hideBtnElement("#repair-request-form .step21kiss .btn.next");
      $this.hideBtnElement("#repair-request-form .step21tv .btn.next");
      $("#selected-appointment-date").val("");
      $("#selected-appointment-time").val("");


      if (
        window.state._selectedservice === 'IHTVDA' && window.state._availableservice === 'IHTVDA' ||
        window.state._selectedservice === 'PSTVDA' && window.state._availableservice === 'PSTVDA'
      ) { 
        $(".container .steps.step3").show();
        $this.step = "step3";
      }else {
        $(".container .steps.step2").show();
        $this.step = "step2";
      }

    } else if ($this.step == "step3") {
      $this.resetForm($("#contact-details"));
      $this.hideBtnElement("#repair-request-form .step3 .btn.next");

      if (window.state.selectedservice == "PS" && site == "uk" && window.state.product != "TV" && window.state.product != "AV") {
        $(".container .steps.step21").show();
        // $this.customSelector.remove();
        $this.step = "step21";
      } else if (window.state.selectedservice == "KISS") {
        $(".container .steps.step21kiss").show();
        // $this.customSelector.remove();
        $this.step = "step21kiss";
      } 
      // else if (window.state.product == "TV" || window.state.product == "AV") {
      //   $(".container .steps.step21tv").show();
      //   // $this.customSelector.remove();
      //   $this.step = "step21tv";
      // } 
      else {
        $(".container .steps.step2").show();
        // $this.customSelector.remove();
        $this.step = "step2";
      }
    } else if ($this.step == "step31") {
      $this.hideBtnElement("#repair-request-form .step31 .btn.next");
      $(".lds-ring").hide();
      $(".confirm-wrapper.step31").html("");
      $(".confirm-wrapper.step31").hide();

      if (
        window.state._selectedservice === 'IHTVDA' && window.state._availableservice === 'IHTVDA' ||
        window.state._selectedservice === 'PSTVDA' && window.state._availableservice === 'PSTVDA'
      ) { 
        $(".container.form").show();
        $(".container .steps.step21tv").show();
        $this.scrollTo("#repair-booking-form");
        
        $this.step = "step21tv";
      } else {
        $(".container.form").show();
        $(".container .steps.step3").show();

        $this.step = "step3";
      }   
    }
  }

  resetForm($form) {
    /** Country filed default value set and disabled it should not reset **/
    $form
      .find(
        "input:text:not([norest]), input:password, input:file, select, textarea"
      )
      .val("");
    $form
      .find("input:radio, input:checkbox")
      .removeAttr("checked")
      .removeAttr("selected");
    //removeAttr is depricate in latest version of Jquery which is used in P6 header;
    $form.find("input:radio, input:checkbox").prop("checked", false);
  }

  changeTimeLine(selectedIssue) {
    const stepTexts = document.querySelectorAll("support-steps p");
    if (window.state._tsoutcome.selectedIssue === selectedIssue ) {
        stepTexts.forEach(function (p) {
        switch (p.textContent) {
          case "Book your repair":
            p.textContent = "Book your appointment";
            break;
          case "Repair summary":
            p.textContent = "Appointment summary";
            break;
        }
      });
    }
  }

  showStep0() {
    var $this = this;
    $this.scrollTo("#repair-booking-form");
    $(".container .steps").hide();
    $(".lds-ring").hide();
    $(".container .steps.step0").show();
    $this.step = "step0";

    //Reset error messages
    $("#serial").css("border", "");
    $("#serial").parent().find(".c-error").text("");
    $("#imei-number").css("border", "");
    $("#imei-number").parent().find(".c-error").text("");
    $("#model").css("border", "");
    $("#model").parent().find(".c-error").text("");

    $this.validate();
    $this.changeTimeLine("Battery Replacement");
  }

  showWarranty(response) {
    var $this = this;

    /** populate model serial imei from pd list and disable those fileds for edit **/
    if (response.modelCode != "") {
      $("#model").val(response.modelCode);
      $("#model").css("border", "");
      $("#model").parent().find(".c-error").text("");
    }

    /** Sent from Sebn server session **/
    /*if (response.serialNo != "") {

        	$('#serial').val(response.serialNo);

        }
*/

    if (response.imeiNo != "") {
      $("#imei-number").val(response.imeiNo);
    }

    $("#product-type").prop("disabled", true);
    $("#model").prop("disabled", true);
    $("#serial").prop("disabled", true);
    $("#imei-number").prop("disabled", true);

    // $('#serial-row').show();
    $("#model-row").show();

    /** hide the pdinfo submit button and show warranty details **/
    $("#pd-info-submit").hide();

    if (window.state.selectedservice == "KISS") {
      $("#kiss-booking-details").show();
      $("#date-of-purchase").datepicker({
        minDate: -29,
        maxDate: "+0D",
        dateFormat: "dd/mm/yy",
      });
      $this.scrollTo("#kiss-booking-details");
    } else {
      $("#warranty-details").show();
      if (window.state.category == "mobile") {
        $("#warranty-details .mx-legal").show();
        $("#warranty-details .generic-legal").hide();
      } else {
        $("#warranty-details .mx-legal").hide();
        $("#warranty-details .generic-legal").show();
      }
      $this.scrollTo("#warranty-details");
    }

    $this.step = "step1";
    $this.validate();

    /*if ($this.isProductInWarranty) {

            //$this.showBtnElement('#warranty-details .btn.next');
            $('#in-warranty').show();

        } else {

           //datePicker(this.formConfigData.date_of_pruchase_eligible_start_date);

            $('#out-of-warranty').show();

        }*/
  }

  proofOfPurchase() {
    var $this = this;
    //reset pop

    if (!window.state.proofOfPurchase) {
        this.proofOfPurchaseReset()
    }

    if ($("#date-of-purchase--pop").length >= 1) {
      $("#date-of-purchase--pop").datepicker({
        minDate: -3652, // 10 years
        maxDate: "+0D",
        dateFormat: "dd/mm/yy",
      });

      $("#date-of-purchase--pop").on("input blur change", function (e) {
        var sErrorNode = $(this).parent().find(".c-error");

        if (e.target.value == '') {
          e.target.style.border = "1px solid #ff001f";
          sErrorNode.text("Date of purchase is required.");
        }  else {
          var dateYear = e.target.value.split("/")[2];

          if ($.trim(dateYear).length != 4) {
            e.target.style.border = "1px solid #ff001f";
            sErrorNode.text("Please enter a valid date (dd/mm/yyyy)");
          } else {
            e.target.style.border = "";
            sErrorNode.text("");
            var dateList = e.target.value.split("/");
            var dateOfPurchase = dateList[2] + dateList[1] + dateList[0];

            if (window.state.proofOfPurchase) {
              window.state.proofOfPurchase.dateOfPurchase = dateOfPurchase

              if (document.getElementById('confirmterms').checked) {
                $this.showBtnElement("#warranty-details .btn.next");
              }
            } else {
              window.state.proofOfPurchase = {}
              window.state.proofOfPurchase.dateOfPurchase = dateOfPurchase

              if (document.getElementById('confirmterms').checked) {
                $this.showBtnElement("#warranty-details .btn.next");
              }
            }
          }
        }

      });
    }




    if (window.state.selectedservice == 'KISS') {
      $("#pop-image-file__DA").on("change", function(e) {
        var reader = new FileReader();
        reader.readAsDataURL(document.getElementById("pop-image-file__DA").files[0]);

        reader.onload = function () {

          if (!window.state.proofOfPurchase) {
            window.state.proofOfPurchase = {}
          }

          window.state.proofOfPurchase.file = reader.result
          window.state.proofOfPurchase.fileBase64 = reader.result.split(',')[1]
          window.state.proofOfPurchase.size = e.target.files[0].size
          window.state.proofOfPurchase.type = e.target.files[0].type.split("/")[1]
          window.state.proofOfPurchase.name = e.target.files[0].name

          $this.proofOfPurchaseShowImage()
        }
        // }

      })
    } else {
      $("#pop-image-file").on("change", function(e) {
        var reader = new FileReader();
        reader.readAsDataURL(document.getElementById("pop-image-file").files[0]);

        reader.onload = function () {
          if (!window.state.proofOfPurchase) {
            window.state.proofOfPurchase = {}
          }

          window.state.proofOfPurchase.file = reader.result
          window.state.proofOfPurchase.fileBase64 = reader.result.split(',')[1]
          window.state.proofOfPurchase.size = e.target.files[0].size
          window.state.proofOfPurchase.type = e.target.files[0].type.split("/")[1]
          window.state.proofOfPurchase.name = e.target.files[0].name

          $this.proofOfPurchaseShowImage()
        }
        // }

      })
    }

  }

  proofOfPurchaseShowImage(){

    var imageFile = window.state.proofOfPurchase.file,
        imageName = window.state.proofOfPurchase.name,
        imageSize = window.state.proofOfPurchase.size,
        imageType = window.state.proofOfPurchase.type,
        imageTypes = ['jpeg', 'jpg', 'png', 'tif', 'tiff', 'pdf']

    var tickIcon = '<svg class="pop-image--tick" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"/></svg>';
    var defaultIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path fill="#d7d7d7" d="M272 54.6L272 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-313.4L139.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 54.6zM208 352L64 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-144 0 0-32 144 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l144 0 0 32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"/></svg>';
    var removeIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zm80 80l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16z"/></svg>';

    if (imageTypes.includes(imageType)) {

      //Max upload 8MB
      if(imageSize / (1024 * 1024) > 8 ) {
        this.proofOfPurchaseReset('<span>Your file size is too big. Please choose a file size 8MB or smaller.</span>')
      } else {

        // Success

        if (imageType == 'pdf') {
          $(".pop-image-file__label").html('<div class="pop-image-success">'+tickIcon+'<span>Upload complete</span></div>')
        } else if (imageType == 'tif' || imageType == 'tiff') {
          $(".pop-image-file__label").html('<div class="pop-image-success">'+tickIcon+'<span>Upload complete</span></div>')
        } else {
          $(".pop-image-file__label").html('<img class="pop-image--insert" alt="'+imageName+'" src="'+imageFile+'"/>')
        }

        $(".pop-image-file__label-message").addClass('pop-image-file__label-message--success')
        $(".pop-image-file__label-message").html('<div class="pop__success-message"><span>'+imageName+'</span><span>Upload complete</span></div><a href="#" role="button" aria-label="Remove attached image" class="pop__success-message-remove">'+removeIcon+'</a>')

        $('#proof-of-purchase__date').show();

        if ($('#date-of-purchase--pop').val() == false) {
          var sErrorNode = $('#date-of-purchase--pop').parent().find(".c-error");
          $('#date-of-purchase--pop').css("border","1px solid #ff001f");
          sErrorNode.text("Date of purchase is required.");

          this.hideBtnElement("#warranty-details .btn.next")
        }
      }
    } else {
      // Wrong format
      this.proofOfPurchaseReset('<span>Your file is in the incorrect format. Please upload your Proof of Purchase as a .jpeg, .jpg, .png, or .pdf file.</span>')
    }

  }

  proofOfPurchaseReset(message = '<span>Please upload your document in the following file types: jpeg, jpg, png, tif, pdf.</span>') {
    var defaultIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path fill="#d7d7d7" d="M272 54.6L272 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-313.4L139.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 54.6zM208 352L64 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-144 0 0-32 144 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l144 0 0 32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"/></svg>';

    $(".pop-image-file__label").html('<div class="pop-image">'+defaultIcon+'</div><span>Choose file.</span><span>Max file size 8MB.</span>')
    $(".pop-image-file__label-message").removeClass('pop-image-file__label-message--success')
    $(".pop-image-file__label-message").html(message)
    $('#proof-of-purchase__date').hide();
    $('#pop-image-file').val('')
    delete window.state.proofOfPurchase
  }

  hidWarranty() {
    $("#product-type").prop("disabled", false);
    $("#model").prop("disabled", false);
    $("#serial").prop("disabled", false);
    $("#imei-number").prop("disabled", false);
    $("#product-type").trigger("change");
    $("#model").trigger("input");
    $("#serial").trigger("input");
    $("#imei-number").trigger("input");
    $("#warranty-details").hide();
    $("#kiss-booking-details").hide();
    $("#in-warranty").hide();
    $("#out-of-warranty").hide();
    $("#pd-info-submit").show();
  }

  /** this method is redundant not used any where needs to be deleted after checking **/
  showStep1() {
    var $this = this;
    // $this.scrollTo('#repair-request-form');
    $this.scrollTo("#repair-booking-form");
    $(".container .steps").hide();
    $(".lds-ring").hide();
    $(".container .steps.step1").show();
    $this.step = "step1";
    //$this.validator.validate($this.step);
    $this.validate();
  }

  showStep2() {
    var $this = this;
    //$this.scrollTo('#repair-request-form');
    $this.scrollTo("#repair-booking-form");
    $(".container .steps").hide();
    $(".container .steps.step2").show();

    if (window.state.selectedservice == "BESPOKE") {
      $(".container .steps.step2 h3").hide();
      $(".container .steps.step2 .pc").hide();
    } else {
      $(".container .steps.step2 h3").show();
      $(".container .steps.step2 .pc").show();
    }

    $this.step = "step2";

    //$this.showSymptoms1();

    // console.log($this.symptoms);
    //$this.validator.validate($this.step);
    $this.validate();
  }

  showStep21() {
    var $this = this;
    //$this.scrollTo('#repair-request-form');
    $this.scrollTo("#repair-booking-form");
    $(".container .steps").hide();

    if (window.state._product == "Vacuum Cleaners") {
      $(".message.center").html(`
        <h4 class="c_tit-type3">Choose a collection date</h4>

        <p>Our courier partner, will collect your device on your chosen date and provide an approximate time for collection on that day.</p>

        <p>Please ensure you provide the full vacuum product, including any accessories that came with the box, battery and any charging components (including the charging station).</p>
      `);
    } else {
      $(".message.center").html(`
        <h4 class="c_tit-type3">Choose a collection date</h4>

        <p>Our courier partner, will collect your device on your chosen date and provide an approximate time for collection on that day.</p>

        <p>Please ensure you allow sufficient time when selecting your collection date, to prepare your device for collection.</p>



      `);
    }

    var dpdSlots = new DpdSlots();
    var slots = dpdSlots.getSlots();

    var slotsHtml = "";

    slots.forEach(function (slot) {
      slotsHtml +=
        '<div data-slot="' +
        slot.slotToSend +
        '" class="slot">' +
        slot.slotToDisplay +
        '<div class="highlight"></div></div>';
    });

    $(".collection-date .collection-slots").html(slotsHtml);

    $(".container .steps.step21").show();
    $this.step = "step21";

    $this.validate();

    $("#repair-request-form .step21 .collection-slots .slot")
      .off("click")
      .on("click", function () {
        $("#repair-request-form .step21 .collection-slots .slot").removeClass(
          "selected"
        );
        $(this).addClass("selected");
        $("#device-collection-date").val($(this).attr("data-slot"));
        $("#device-collection-date").trigger("input");
      });

    //$this.showSymptoms1();

    // console.log($this.symptoms);
    //$this.validator.validate($this.step);
  }

  showStep21Kiss() {
    var $this = this;
    //$this.scrollTo('#repair-request-form');
    $this.scrollTo("#repair-booking-form");
    $(".container .steps").hide();
    if (
      window.state.category == "homeappliance" || window.state.category == "tvav" &&
      window.state.product != "Vacuum Cleaners" &&
      site == "uk"
    ) {
      $(".kab__modal--content .kissTitle").html(`
      <h2>Choose a preferred appointment date</h2><br>

      <p>Tell us when works for you.</p><br>
      <p>Our Authorised Service Partner will get in touch within 2 working days to let you know if your preferred date is available.</p>
    `);
    } else {
      $(".kab__modal--content .kissTitle").html(`
      <h2>Choose a preferred appointment date and time</h2>

      <p>Our Authorised Service Partner will get in touch with you within 2 working
      days to confirm the date and time of your appointment.</p>
    `);
    }

    var kissSlots = new KissSlots();

    $(".container .steps.step21kiss").show();
    $this.step = "step21kiss";

    $this.validate();
  }

  showStep21Tv() {
    var $this = this;
    $this.scrollTo("#repair-booking-form");
    $(".container .steps").hide();

    var tvSlots = new TvSlots();

    $(".container .steps.step21tv").show();
    $this.step = "step21tv";

    $this.validate();
  }

  showStep3() {
    var $this = this;
    //$this.scrollTo('#repair-request-form');
    $this.scrollTo("#repair-booking-form");
    $(".container .steps").hide();
    $(".container .steps.step3").show();
    $this.step = "step3";
    $this.validate();
    /** if Autocomplete not closed by user manually and they select different service close it when load step3 **/
    $(".contact-details .autocomplete-items").remove();

    // Remove previously selected collection option **/
    $("#repair-request-form .step3 .collection-opt .radio").removeClass(
      "selected"
    );
    $("#repair-request-form .step3 .collection-opt").find("input").val("");

    if (
      window.state.userInfo.firstName != "" &&
      typeof window.state.userInfo.firstName != "undefined"
    ) {
      $("#contact-details #firstname").val(window.state.userInfo.firstName);
      $("#contact-details #firstname").trigger("input");
    }
    if (
      window.state.userInfo.lastName != "" &&
      typeof window.state.userInfo.lastName != "undefined"
    ) {
      $("#contact-details #lastname").val(window.state.userInfo.lastName);
      $("#contact-details #lastname").trigger("input");
    }
    if (
      window.state.userInfo.email != "" &&
      typeof window.state.userInfo.email != "undefined"
    ) {
      $("#contact-details #email").val(window.state.userInfo.email);
      $("#contact-details #email").trigger("input");
      $("#contact-details #confirmemail").val(window.state.userInfo.email);
      $("#contact-details #confirmemail").trigger("input");
      $("#contact-details #confirmemail").parents(".row").hide();
      $("#contact-details #email").attr("readonly", true);
      //$("#contact-details #confirmemail").hide();
    } else {
      $("#contact-details #email").attr("readonly", false);
    }

    // revert the previous validation

    //$this.events();
    // $this.validator.validate($this.step);
    $("#phonenumber").css({ "border-color": "" });
    $("#firstname").css({ "border-color": "" });
    $("#lastname").css({ "border-color": "" });
    $("#email").css({ "border-color": "" });
    $("#confirmemail").css({ "border-color": "" });
    $("#phonenumber").parent().find(".c-error").text("");
    $("#firstname").parent().find(".c-error").text("");
    $("#lastname").parent().find(".c-error").text("");
    $("#email").parent().find(".c-error").text("");
    $("#confirmemail").parent().find(".c-error").text("");

    // For Croydon store hide the one to one collection option
    //window.state.selectedstoreid == 4549 - Glasgow store
    /*if ( window.state.selectedstoreid == 4548 || window.state.selectedstoreid == 4549) {

            $('#device-pickup-option').val('Collection Locker');
            $('#device-pickup-option').trigger('input');
            $('.lockers-only-pickup-row').show();
            $('.device-pickup-options-row').hide();


           //$('.collection-opt .radio[data-value="Collection Locker"]').hide();
            //$('.collection-opt .radio[data-value="Collection 121"]').hide();
            //$('.collection-opt .radio[data-value="CI LO"]').hide();

        }*/
    if (window.state._tsoutcome.selectedIssue === 'Battery Replacement') {
      //add class 'selected here
      $("#contact-details .row.device-pickup-options-row .collection-opt .radio")[0].classList.add("selected");
      $("#contact-details .row.device-pickup-options-row .collection-opt .radio")[0].click();
      $('.device-pickup-options-row').hide();
    }
  }

  showStep31() {
    var $this = this;

    //$this.scrollTo('#repair-request-form');
    $this.scrollTo("#repair-booking-form");
    $(".container.form").hide();
    $("#repair_summary").hide();

    var confirmData = $this.getConfirmPageDetails();
    var imeiOrSerialNumber = "";

    if (window.state.product == "Smartphones") {
      imeiOrSerialNumber +=
        $this.deviceDetails.imeiNumber == ""
          ? ""
          : "IMEI number: " + $this.deviceDetails.imeiNumber;
    } else {
      imeiOrSerialNumber +=
        $this.deviceDetails.serial == ""
          ? ""
          : "Serial number: " + $this.deviceDetails.serial;
    }

    //imeiOrSerialNumber += ($this.deviceDetails.imeiNumber != "" && $this.deviceDetails.serial != "")? "<br />":"";
    //imeiOrSerialNumber += ($this.deviceDetails.serial== "")? "" : "Serial number: "+$this.deviceDetails.serial;
    if (
      window.state.category == "homeappliance" &&
      window.state.product != "Vacuum Cleaners" &&
      site == "uk" &&
      window.state.selectedservice == "KISS"
    ) {
      var source = this.templates.confirmYourBookingKiss;
    }
    else if (
      window.state.category == "tvav" &&
      window.state.product != "Vacuum Cleaners" &&
      site == "uk" &&
      window.state.selectedservice == "KISS"
    ) {
      var source = this.templates.confirmYourBookingTvAv;
    }
    else {
      var source = this.templates.confirmYourBooking;
    }

    var template = Handlebars.compile(source);
    var compiled = template({
      contactDetails: $this.contactDetails,
      deviceDetails: $this.deviceDetails,
      imeiOrSerialNumber: imeiOrSerialNumber,
      confirmData: confirmData,
      proofOfPurchase: window.state.proofOfPurchase ? window.state.proofOfPurchase.name ? window.state.proofOfPurchase.name : false : false
    });

    $(".confirm-wrapper.step31").html(compiled);
    $(".confirm-wrapper.step31").show();
    $this.step = "step31";
    $("#repair-request-form .step31 .btn.next").removeAttr("disabled");
    $("#repair-request-form .step31 .btn.next").addClass("blue");

    //Update top time line
    window.supportComponents.steps.setActiveStep(4);
    const stepTexts = document.querySelectorAll("support-steps p");
    if (
      window.state.category == "homeappliance" || window.state.category == "tvav" &&
      window.state.product != "Vacuum Cleaners" &&
      site == "uk" &&
      window.state.selectedservice == "KISS"
    ) {

      stepTexts.forEach(function (p) {
        switch (p.textContent) {
          case "Book your repair":
            p.textContent = "Request appointment";
            break;
          case "Confirm your booking":
            p.textContent = "Send request";
            break;
          case "Repair summary":
            p.textContent = "Request summary";
            break;
        }
      });
    }
    $this.changeTimeLine("Battery Replacement");
    if (window.state._tsoutcome.selectedIssue === 'Battery Replacement') {
      $this.batteryReplacementConfirmBookingTextChanges();
    }
    $this.events();


    //$this.soCreateResponse={"tsdetails":[{"lucidRef":"97-148973893","symptomCode1":"99","symptomCode2":"99","symptomCode3":"99","warrantyException":"VOID1"}],"serialnumber":"RFAM90LPWYF","storeDetails":{"storeType":"SES","serviceType":"in-store","storeId":"4569","productId":68317,"bookinWidgetId":"7VHWRXREAKT"},"slotDetails":{"slotStartDateTime":"2022-12-13T10:30:00.000000+00:00","reservationId":"1f92fbf0-07f0-4975-adb1-a64342d827ff"},"success":true,"headerCode":"200","headerCodeDesc":"Success","bodyCode":"200","bodyCodeDesc":"Success","reservation":{"venueId":"4569","productId":"68317","addOnIds":[],"staffId":null,"reservationId":"1f92fbf0-07f0-4975-adb1-a64342d827ff","startDateTime":"2022-12-13T10:30:00.000000+00:00","endDateTime":"2022-12-13T11:00:00.000000+00:00","expirationDateTime":"2022-12-07T21:04:19.000000+00:00","createdOnDateTime":"2022-12-07T20:59:19.000000+00:00","customerDetails":{"firstName":"Mohanram","lastName":"Seenivasan","email":"ramneravi@gmail.com","phoneNumber":null,"postcode":null,"receiveSmsReminder":false,"notes":"Drop Off 121 \/ CI LO, Troubleshooter reference number: 97-148973893 test","title":null,"groupSize":1,"orderNumber":"5100027374","lang":null,"externalId":null},"customerAnswers":null},"serviceRequestNo":"5100027374","bookingId":"c6e6f3ebedbcc4829b63c67c5b08db5bc"}
    //$this.showStep4();
  }

  batteryReplacementConfirmBookingTextChanges() {

    const overViewListItem = document.querySelectorAll('.overview-list-item');
    overViewListItem.forEach((x, i) => {
        if (i === 2) {
            const subTitle = x.querySelector('.sub-title');
            const text = x.querySelector('.text');

            subTitle.innerText = 'Booking Information:';
            text.innerText = 'Battery Replacement Service';
        }
    });
  }

  changeCalendarText() {
    var calendarContainerTitle = $('.steps.step21tv .tvab__modal--content h2')
    var calendarContainerDescription = $('.steps.step21tv .tvab__modal--content p')

    if (
      window.state._selectedservice === 'IHTVDA' && window.state._availableservice === 'IHTVDA'
    ) { 
      calendarContainerTitle.html('Choose a preferred appointment date')
      calendarContainerDescription.html('Please select a preferred appointment date and our Authorised Service Partner will be in touch to confirm a date and time')
    } else if(window.state._selectedservice === 'PSTVDA' && window.state._availableservice === 'PSTVDA') {
      calendarContainerTitle.html('Choose a preferred collection date')
      calendarContainerDescription.html('Please select a preferred collection date and our Authorised Service Partner will be in touch to confirm a date and time.')
    } else {
      calendarContainerTitle.html('Choose a preferred collection date.')
      calendarContainerDescription.html('Our Authorised Service Partner will get in touch with you within 2 working days to confirm the date of your appointment.')
    }
  }

  showStep4() {
    var $this = this;
    // console.log("soCreateResponse", $this.soCreateResponse);
    var soCreateResponse = $this.soCreateResponse;
    var qudiniResponse = $this.qudiniResponse;

    window.supportComponents.steps.setActiveStep(5);

    $this.doLog("SO Create Response", soCreateResponse);

    if (
      typeof soCreateResponse != "undefined" &&
      soCreateResponse.success == true
    ) {

      if (typeof ga === "function") {
        ga("create", $this.gaId, {
          name: "gtm9998",
          cookieExpires: "33696000",
          cookieDomain: "auto",
        });
        ga("gtm9998.send", {
          hitType: "event",
          eventCategory: "repair",
          eventAction: "booking",
          eventLabel: "so create success",
          dimension22: $this.soCreateResponse.serviceOrderNo,
        });
      }

      window.state.QSIRepairBookingFlag = "Booking Success";
    } else {
      if (typeof ga === "function") {
        ga("create", $this.gaId, {
          name: "gtm9994",
          cookieExpires: "33696000",
          cookieDomain: "auto",
        });
        ga("gtm9994.send", {
          hitType: "event",
          eventCategory: "repair",
          eventAction: "booking",
          eventLabel: "so create fail",
        });
      }
      window.state.QSIRepairBookingFlag = "Booking failed";
    }
    /** Qualtrics survey code **/
    if (typeof QSI !== "undefined" && $this.isObject(QSI)) {
      QSI.API.unload();
      QSI.API.load();
      QSI.API.run();
    }

    // Proof of Purchase
    if (
      typeof soCreateResponse != "undefined" &&
      soCreateResponse.success == true &&
      window.state.proofOfPurchase &&
      window.state.proofOfPurchase.file
    ) {
      $this.doProofOfPurchase(soCreateResponse)
    } else {
      $this.drawThankyouPage();
    }


  }

  /*      this.templates.bookingSuccess
        this.templates.bookingfail
        this.templates.fail400
        this.templates.fail401
        this.templates.fail458
        this.templates.fail478
        this.templates.fail902
    showStep4()
    $this.lucidRef = 97-58819109;
    $this.soCreateResponse.success =false;
    $this.soCreateResponse.bodyCode = '478';
    window.state.selectedservice == "ISR";


        */

  getConfirmPageDetails() {
    var $this = this;

    const formatAMPM = function (date) {
      let hours = "";
      let minutes = "";

      if (typeof date === "string") {
        hours = date.substring(0, 2);
        minutes = date.substring(2, 4);
      } else if (typeof date === "object") {
        hours = date.getHours();
        minutes = date.getMinutes();

        hours = hours < 10 && hours >= 0 ? `0${hours}` : hours;
        minutes = minutes < 10 && minutes >= 0 ? `0${minutes}` : minutes;
      }

      let strTime = "";

      if (window.state.timeBooked && window.state.product == "TV") {
        if (window.state.timeBooked == "Book now") {
          strTime = `09:00 - 17:00`;
        } else if (window.state.timeBooked == "AM") {
          strTime = `09:00 - 13:00`;
        } else if (window.state.timeBooked == "PM") {
          strTime = `13:00 - 17:00`;
        }
      } else {
        strTime = `${hours}:${minutes}`;
      }

      return strTime;
    };

    const nth = function (d) {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    /** Date formate to Display in front end **/
    const dateformatedis = function (dateObj, istime) {
      const date = dateObj.getDate();
      const monthYear = dateObj.toLocaleString("default", {
        year: "numeric",
        month: "long",
        hour12: true,
      });
      var formatedDate = "";
      if (!istime) {
        formatedDate = `${date}<sup>${nth(date)}</sup> ${monthYear}`;
      } else {
        formatedDate = `${date}<sup>${nth(
          date
        )}</sup> ${monthYear}<br /> ${formatAMPM(dateObj)}`;
      }

      return formatedDate;
    };

    const dateStringToDate = function (dateString) {
      try {
        var year = dateString.substring(0, 4);
        var month = dateString.substring(4, 6);
        var day = dateString.substring(6, 8);
        var dateObj = new Date(year, month - 1, day);
        return dateObj;
      } catch (error) {
        return null;
      }
    };

    //let dateObj = new Date('2022-12-01T10:00:00.000000+00:00');
    var selectedService = "";
    var selectedDate = "";
    var address = "<h6 class='sub-title'>Home</h6><p class='text'>";
    var appointmentLocText = "Appointment location";
    //var address = "<strong>Home</strong><br />";

    // console.log($this.contactDetails);

    if ($this.contactDetails != "undefined") {
      address +=
        $this.contactDetails.address1 == "" ||
        $this.contactDetails.address1 == "undefined"
          ? ""
          : $this.contactDetails.address1 + ", ";
      address +=
        $this.contactDetails.address2 == "" ||
        $this.contactDetails.address2 == "undefined"
          ? ""
          : $this.contactDetails.address2 + ", ";
      address +=
        $this.contactDetails.address3 == "" ||
        $this.contactDetails.address3 == "undefined"
          ? ""
          : $this.contactDetails.address3 + ", ";
      address +=
        $this.contactDetails.town == "" ||
        $this.contactDetails.town == "undefined"
          ? ""
          : $this.contactDetails.town + ", ";
      address +=
        $this.contactDetails.country == "" ||
        $this.contactDetails.country == "undefined"
          ? ""
          : $this.contactDetails.country;
      address +=
        $this.contactDetails.postcode == "" ||
        $this.contactDetails.postcode == "undefined"
          ? ""
          : ", " + $this.contactDetails.postcode;

      /* if (site === 'ie') {

            address += ($this.contactDetails.postcode == "" || $this.contactDetails.postcode == "undefined")? "" : $this.contactDetails.postcode;

            } else {

            address += ($this.contactDetails.postcode == "" || $this.contactDetails.postcode == "undefined")? "" : $this.contactDetails.postcode;

            }*/
    }
    address += "</p>";

    var deviceDetails = $this.deviceDetails;
    /** place holder icon **/
    var selectedServiceIcon =
      "https://images.samsung.com/is/image/samsung/assets/uk/support/repair/icon-display.png?$ORIGIN_PNG$";
    var selectedServiceIconAltTxt = "Selected service icon";

    switch (window.state.selectedservice) {
      case "ISR":
        selectedService = "In-store Repair";
        address =
          "<h6 class='sub-title'>" +
          window.state.selectedStoreAndSlot.storeName +
          "</h6><p class='text'>";
        address += window.state.selectedStoreAndSlot.storeAddress + "</p>";
        selectedDate =
          "<h6 class='sub-title'>Appointment date:</h6><p class='text'><span class='date'>" +
          dateformatedis(
            new Date(window.state.selectedStoreAndSlot.selectedSlot),
            true
          ) +
          "</span></p>";
        selectedServiceIcon =
          "https://images.samsung.com/is/content/samsung/assets/uk/support/repair/ux-update/icons/__In-store-repair_dm.svg";
        selectedServiceIconAltTxt = "Men and women with speech bubble icon";
        break;

      case "PS":
        selectedService = "Pick up Repair";
        // console.log("tvInDays homeRepair PS", selectedService);
        var styleAttribute = site === "ie" ? " style='display:none'" : "";
        if (deviceDetails.collectionDate != "") {
          selectedDate =
            "<h6 class='sub-title'" +
            styleAttribute +
            ">Collection date:</h6><p class='text'" +
            styleAttribute +
            "><span class='date'>" +
            dateformatedis(
              dateStringToDate(deviceDetails.collectionDate),
              false
            ) +
            "</span></p>";
        }
        if (window.state.product == "TV" || window.state.product == "AV") {
          appointmentLocText = "Collection location";
          selectedDate =
            "<h6 class='sub-title'>Requested collection date:</h6><p class='text'><span class='date'>" +
            dateformatedis(
              dateStringToDate(deviceDetails.appointmentDate),
              false
            ) +
            "<br>" +
            formatAMPM(deviceDetails.appointmentTime) +
            "</span></p>";
        } else if (deviceDetails.appointmentDate) {
          selectedDate =
            "<h6 class='sub-title'>Appointment date:</h6><p class='text'><span class='date'>" +
            dateformatedis(
              dateStringToDate(deviceDetails.appointmentDate),
              false
            ) +
            "<br>" +
            formatAMPM(deviceDetails.appointmentTime) +
            "</span></p>";
        }

        selectedServiceIcon =
          "https://images.samsung.com/is/content/samsung/assets/uk/support/repair/ux-update/icons/__Pick-up-repair_dm.svg";
        selectedServiceIconAltTxt = "Loader trolley with boxes icon";
        break;

      case "IH":
        // selectedService =
        //   window.state.product == "TV"
        //     ? "In-home or Pick-up Repair"
        //     : "In-home Repair";
        selectedService = "In-home Repair";
        // console.log("tvInDays homeRepair IH", selectedService);
        selectedServiceIcon =
          "https://images.samsung.com/is/content/samsung/assets/uk/support/repair/ux-update/icons/__In-home-repair_dm.svg";
        selectedServiceIconAltTxt = "Men and home icon";
        if (deviceDetails.appointmentDate) {
          selectedDate =
            "<h6 class='sub-title'>Appointment date:</h6><p class='text'><span class='date'>" +
            dateformatedis(
              dateStringToDate(deviceDetails.appointmentDate),
              false
            ) +
            "<br>" +
            formatAMPM(deviceDetails.appointmentTime) +
            "</span></p>";
        }
        break;

        case "IHTVDA":
          // selectedService =
          //   window.state.product == "TV"
          //     ? "In-home or Pick-up Repair"
          //     : "In-home Repair";
          selectedService = "In-home Repair";
          // console.log("tvInDays homeRepair IH", selectedService);
          selectedServiceIcon =
            "https://images.samsung.com/is/content/samsung/assets/uk/support/repair/ux-update/icons/__In-home-repair_dm.svg";
          selectedServiceIconAltTxt = "Men and home icon";
          if (deviceDetails.appointmentDate) {
            selectedDate =
              "<h6 class='sub-title'>Appointment date:</h6><p class='text'><span class='date'>Authorised Service Partner to confirm</span></p>";
          }
          break;  
        
        case "PSTVDA":
          selectedService = "Pick up Repair";
          // console.log("tvInDays homeRepair PS", selectedService);
          var styleAttribute = site === "ie" ? " style='display:none'" : "";
          if (deviceDetails.collectionDate != "") {
            selectedDate =
              "<h6 class='sub-title'" +
              styleAttribute +
              ">Collection date:</h6><p class='text'" +
              styleAttribute +
              "><span class='date'></span></p>";
          }
          if (window.state.product == "Vacuum Cleaners") {
            selectedDate =
              "<h6 class='sub-title'>Appointment date:</h6><p class='text'><span class='date'>" +
              dateformatedis(
                dateStringToDate(deviceDetails.appointmentDate),
                false
              ) 
              "</span></p>";
          } else if (deviceDetails.appointmentDate) {
            appointmentLocText = "Collection location";
            selectedDate =
              "<h6 class='sub-title'>Collection date:</h6><p class='text'><span class='date'>Authorised Service Partner to confirm</span></p>";
          }
  
          selectedServiceIcon =
            "https://images.samsung.com/is/content/samsung/assets/uk/support/repair/ux-update/icons/__Pick-up-repair_dm.svg";
          selectedServiceIconAltTxt = "Loader trolley with boxes icon";
          break;   

      case "KISS":
        //selectedService = "KISS Repair";
        selectedService = "In-home Repair";
        selectedDate =
          "<h6 class='sub-title'>Preferred appointment date:</h6><p class='text'><span class='date'>" +
          dateformatedis(
            dateStringToDate(deviceDetails.appointmentDate),
            false
          ) +
          "<br>" +
          formatAMPM(deviceDetails.appointmentTime) +
          "</span></p>";
        selectedServiceIcon =
          "https://images.samsung.com/is/content/samsung/assets/uk/support/repair/ux-update/icons/__In-home-repair_dm.svg";
        selectedServiceIconAltTxt = "Men and home icon";
        break;

      case "BESPOKE":
        selectedService = "Bespoke Repair";
        selectedDate =
          "<h6 class='sub-title'>Collection date:</h6><p class='text'><span class='date'>" +
          dateformatedis(
            dateStringToDate(deviceDetails.collectionDate),
            false
          ) +
          "</span></p>";
        selectedServiceIcon =
          "https://images.samsung.com/is/content/samsung/assets/uk/support/repair/ux-update/icons/__Pick-up-repair_dm.svg";
        selectedServiceIconAltTxt = "Loader trolley with boxes icon";
        break;
    }

    var selectedProductImage =
      "https://images.samsung.com/is/image/samsung/assets/uk/support/repair-devices/" +
      window.state.productImage.replace(/\s+/g, '') +
      "?$ORIGIN_PNGS$";

    // Some times image is missing in thank you page(no loading), so we re preloading the image.
    var prodImg = new Image();
    prodImg.src = selectedProductImage;

    var selectedProduct = window.state.tsoutcome.tsProductNameForDisplay;
    var repairStepsVideoHash =
      window.state.category == "mobile" ? "H1UECEqQUWk" : "-ABKlRBjd8U";

    var repairStepsVideoHash = this.thankyouPageVideo;

    // Steps for thank you page
    if (site == "uk") {
      var mobileSteps = `<li class="overview-list-item">
                    <p><strong>Step 1: Back up your data</strong></p>
                    <p> Please ensure your device data is backed up before the repair.</p>
                    <p><a target=”_blank” href="https://www.samsung.com/uk/support/mobile-devices/backing-up-and-restoring-data-on-my-galaxy/" target="_blank">Help</a> on backing up your data </p>
                </li>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 2: Remove your Samsung and Google accounts.</strong></p>
                    <p><a target=”_blank” href="https://www.samsung.com/uk/support/mobile-devices/how-to-remove-accounts-from-your-galaxy-phone-or-tablet/" target="_blank">Help</a> on removing accounts</p>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 3: Remove any accessories unrelated to your issue.</strong> </p>
                    <p>Remove accessories such as cases and covers.</p>
                </li>`;
    }
    if (site == "ie") {
      var mobileSteps = `<li class="overview-list-item">
                    <p><strong>Step 1: Back up your data</strong></p>
                    <p> Please ensure your device data is backed up before the repair.</p>
                    <p><a target=”_blank” href="https://www.samsung.com/ie/support/mobile-devices/backing-up-and-restoring-data-on-my-galaxy/" target="_blank">Help</a> on backing up your data </p>
                </li>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 2: Remove your Samsung and Google accounts.</strong></p>
                    <p><a target=”_blank” href="https://www.samsung.com/ie/support/mobile-devices/how-to-remove-accounts-from-your-galaxy-phone-or-tablet/" target="_blank">Help</a> on removing accounts</p>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 3: Remove any accessories unrelated to your issue.</strong> </p>
                    <p>Remove accessories such as cases and covers.</p>
                </li>`;
    }

    var haSteps = `<li class="overview-list-item">
                    <p><strong>Step 1: Clean your product</strong></p>
                    <p>Please wipe down your product so it is clean and sanitary.</p>
                </li>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 2: Create space</strong></p>
                    <p>Make sure there is enough space around your product.</p>
                    <p>Appliances should not be stacked on one another. If your product is a TV please remove it from the wall before the technician arrives.</p>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 3: Proof of purchase</strong> </p>
                    <p>Have your proof of purchase available for engineer, if possible.</p>
                </li>`;
    var haStepsKiss = `<li class="overview-list-item">
                  <p><strong>Step 1: Clean your product</strong></p>
                  <p>Please wipe down your product so it is clean and sanitary.</p>
              </li>
              </li>
              <li class="overview-list-item">
                  <p><strong>Step 2: Create space</strong></p>
                  <p>Make sure there is enough space around your product.</p>
                  <p>Appliances should not be stacked on one another. If your product is a TV please remove it from the wall before the engineer arrives.</p>
              </li>
              <li class="overview-list-item">
                  <p><strong>Step 3: Proof of purchase</strong> </p>
                  <p>Have your proof of purchase available for the engineer.</p>
              </li>`;

    var tvavSteps = `<li class="overview-list-item">
                    <p><strong>Step 1: Clean your product</strong></p>
                    <p>Please wipe down your product so it is clean and sanitary.</p>
                </li>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 2: Create space</strong></p>
                    <p>Make sure there is enough space around your product.</p>
                    <p>Appliances should not be stacked on one another. If your product is a TV please remove it from the wall before the technician arrives. </p>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 3: Proof of purchase</strong> </p>
                    <p>Have your proof of purchase available for engineer, if possible.</p>
                </li>`;

    var computingSteps = `<li class="overview-list-item">
                    <p><strong>Step 1: Clean your product</strong></p>
                    <p>Please wipe down your product so it is clean and sanitary.</p>
                </li>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 2: Create space</strong></p>
                    <p>Make sure there is enough space around your product.</p>
                    <p>Appliances should not be stacked on one another. If your product is a TV please remove it from the wall before the technician arrives. </p>
                </li>
                <li class="overview-list-item">
                    <p><strong>Step 3: Proof of purchase</strong> </p>
                    <p>Have your proof of purchase available for engineer, if possible.</p>
                </li>`;
    var thankyouSteps;
    if (window.state.category == "mobile") {
      thankyouSteps = mobileSteps;
    } else if (
      window.state.category == "homeappliance" || window.state.category == "tvav" &&
      window.state.product != "Vacuum Cleaners" &&
      site == "uk" &&
      window.state.selectedservice == "KISS"
    ) {
      thankyouSteps = haStepsKiss;
    } else {
      thankyouSteps = haSteps;
    }

    return {
      selectedService,
      selectedDate,
      address,
      appointmentLocText,
      selectedProduct,
      selectedProductImage,
      deviceDetails,
      repairStepsVideoHash,
      thankyouSteps,
      selectedServiceIcon,
      selectedServiceIconAltTxt,
    };
  }

  drawThankyouPage() {
    var $this = this;
    var soCreateResponse = $this.soCreateResponse;
    var soPOPResponse;

    if ($this.soCreateResponsePOP) {
      soPOPResponse = $this.soCreateResponsePOP
    }


    var template = "";
    var compiled = "";

    var bookingRef =
      window.state.selectedservice != "ISR"
        ? soCreateResponse.serviceOrderNo
        : soCreateResponse.serviceRequestNo;

    var confirmData = $this.getConfirmPageDetails();
    if (
      typeof soCreateResponse != "undefined" &&
      soCreateResponse.success == true
    ) {
      console.log("succesSO");

      $("#content").removeClass("mobile-tablet homeappliance tvav itrepair");

      /**if (window.state.selectedservice == "KISS") {

                // Door replacement
                if (window.state.tsoutcome.outcome == "ihIIbooking") {

                    template = Handlebars.compile($this.templates.bookingSuccessKissII);

                } else {

                    template = Handlebars.compile($this.templates.bookingSuccessKiss);

                }


            } else {

                template = Handlebars.compile($this.templates.bookingSuccess);

            }**/

      if (
        window.state.category == "homeappliance" || window.state.category == "tvav" &&
        window.state.product != "Vacuum Cleaners" &&
        site == "uk" &&
        window.state.selectedservice == "KISS"
      ) {
        template = Handlebars.compile($this.templates.thankyoukiss);
        const stepTexts = document.querySelectorAll("support-steps p");

        stepTexts.forEach(function (p) {
          switch (p.textContent) {
            case "Book your repair":
              p.textContent = "Request appointment";
              break;
            case "Confirm your booking":
              p.textContent = "Send request";
              break;
            case "Repair summary":
              p.textContent = "Request summary";
              break;
          }
        });
      } else {
        template = Handlebars.compile($this.templates.thankyou);
      }
      if (window.state._tsoutcome.selectedIssue === 'Battery Replacement') {
        const stepTexts = document.querySelectorAll("support-steps p");
        stepTexts.forEach(function (p) {
          switch (p.textContent) {
            case "Book your repair":
              p.textContent = "Book your appointment";
              break;
            case "Repair summary":
              p.textContent = "Appointment summary";
              break;
          }
        });
      }

      compiled = template({
        bookingRef: bookingRef,
        confirmData: confirmData,
        site: site,
        popError: soPOPResponse ? soPOPResponse.success ? false : true : false,
        isBatteryReplacement: window.state._tsoutcome && window.state._tsoutcome.selectedIssue === 'Battery Replacement',
        serviceType: window.state._availableservice === 'PSTVDA' ? 'Collection details' : 'Appointment details'
      });


      $this.resetCookieValues();
      $this.showCompiledStep4(compiled, confirmData);
    } else if (
      typeof soCreateResponse != "undefined" &&
      soCreateResponse.success == false
    ) {
      var errorCode = soCreateResponse.bodyCode;

      switch (errorCode) {
        case "400":
          template = Handlebars.compile($this.templates.fail400);
          break;
        case "401":
          template = Handlebars.compile($this.templates.fail401);
          break;
        case "458":
          template = Handlebars.compile($this.templates.fail458);
          break;
        case "478":
          if (window.state.selectedservice == "ISR") {
            template = Handlebars.compile($this.templates.failsr478);
          } else {
            template = Handlebars.compile($this.templates.fail478);
          }
          break;
        case "902":
          template = Handlebars.compile($this.templates.fail902);
          break;
        default:
          console.log("Inside default error template selection");

          template = Handlebars.compile($this.templates.bookingfail);
          break;
      }

      compiled = template({
        lucidRef: $this.lucidRef,
        site: site,
        state: window.state,
        errorCode: errorCode,
      });

      $this.resetCookieValues();
      $this.showCompiledStep4Error(compiled);
    } else {
      template = Handlebars.compile($this.templates.bookingfail);
      compiled = template({
        lucidRef: $this.lucidRef,
        site: site,
        state: window.state,
      });

      $this.resetCookieValues();
      $this.showCompiledStep4Error(compiled);
    }
  }

  showPendingTicketExistMsg() {
    var $this = this;

    $("#device-details")[0].reset();

    var template = Handlebars.compile($this.templates.fail478);

    // console.log("Inside show Pending ticket exist msg");
    // console.log(window.state.selectedservice);

    if (window.state.selectedservice == "ISR") {
      template = Handlebars.compile($this.templates.failsr478);
    }

    var compiled = template({
      lucidRef: $this.lucidRef,
      site: site,
      state: window.state,
    });

    $this.resetCookieValues();
    $this.showCompiledStep4Error(compiled);
  }

  showRepeatRequestMsg() {
    var $this = this;
    $this.resetCookieValues();
    $("#device-details")[0].reset();

    var template = Handlebars.compile($this.templates.failRepeatRepairReq);
    var compiled = template({
      lucidRef: $this.lucidRef,
      site: site,
      state: window.state,
    });

    $this.showCompiledStep4Error(compiled);
  }

  showBespokeWrongIMEINumberMsg() {
    var $this = this;
    $this.resetCookieValues();
    $("#device-details")[0].reset();

    var template = Handlebars.compile($this.templates.failBespokeNotAFlipSku);
    var compiled = template({
      site: site,
      state: window.state,
    });

    $this.showCompiledStep4Error(compiled);
  }

  showTooManyAttemptsMsg(bodyCode) {
    var $this = this;
    /** only reset the cookies only for the errors Lucid ref empty **/
    if (bodyCode == 400) {
      $this.resetCookieValues();
    }
    $("#device-details")[0].reset();

    var template = Handlebars.compile($this.templates.fail403);
    var compiled = template({
      lucidRef: $this.lucidRef,
      site: site,
      state: window.state,
    });

    $this.showCompiledStep4Error(compiled);
  }

  showCompiledStep4Error(compiled) {
    var $this = this;
    //$this.scrollToWithTime('#repair-request-form', 10);
    $this.scrollToWithTime("#repair-request-form", 10);
    $(".container .steps.step4").html(compiled);
    $(".lds-ring").hide();
    $(".container .steps").hide();
    $(".container.form").show();
    $(".confirm-wrapper.steps").hide();
    $(".container .steps.step4").show(1);
    this.chatBotOpen = false;

    window.sprChatSettings = {
      skin: "CLASSIC",
    };
    $('.confirm-message a[title$="Live Chat"]').off("click");
    $('.confirm-message a[title$="Live Chat"]')
      .off("click")
      .on("click", (e) => {
        e.preventDefault();
        // filter value for reports
        window.sprChat("updateClientContext", {
          _c_65a7cc9c3bd1664f2fdcfaa6: ["No"],
        });
        if (window.state.category == "mobile") {
          window.sprChat("updateClientContext", {
            _c_656090b343743730688d8a00: ["Yes"], //Mobile Yes or No
            _c_656090f243743730688db608: ["No"], //HA Yes or No
            _c_6560912b43743730688ddf16: ["No"], //TV Yes or no
            _c_6560915e43743730688e084d: ["No"], //Computer Yes or no
            // sub categroy
            _c_65771084f23a9b229d7cc53c: [window.state.product],
            _c_657710b3f23a9b229d7d07cf: [""],
            _c_657710f2f23a9b229d7d6824: [""],
            _c_65771135f23a9b229d7dd8c0: [""],
          });
        } else if (window.state.category == "homeappliance") {
          window.sprChat("updateClientContext", {
            _c_656090b343743730688d8a00: ["No"], //Mobile Yes or No
            _c_656090f243743730688db608: ["Yes"], //HA Yes or No
            _c_6560912b43743730688ddf16: ["No"], //TV Yes or no
            _c_6560915e43743730688e084d: ["No"], //Computer Yes or no
            // sub categroy
            _c_65771084f23a9b229d7cc53c: [""],
            _c_657710b3f23a9b229d7d07cf: [window.state.product],
            _c_657710f2f23a9b229d7d6824: [""],
            _c_65771135f23a9b229d7dd8c0: [""],
          });
        } else if (window.state.category == "tvav") {
          window.sprChat("updateClientContext", {
            _c_656090b343743730688d8a00: ["No"], //Mobile Yes or No
            _c_656090f243743730688db608: ["No"], //HA Yes or No
            _c_6560912b43743730688ddf16: ["Yes"], //TV Yes or no
            _c_6560915e43743730688e084d: ["No"], //Computer Yes or no
            // sub categroy
            _c_65771084f23a9b229d7cc53c: [""],
            _c_657710b3f23a9b229d7d07cf: [""],
            _c_657710f2f23a9b229d7d6824: [window.state.product],
            _c_65771135f23a9b229d7dd8c0: [""],
          });
        } else if (window.state.category == "itrepair") {
          window.sprChat("updateClientContext", {
            _c_656090b343743730688d8a00: ["No"], //Mobile Yes or No
            _c_656090f243743730688db608: ["No"], //HA Yes or No
            _c_6560912b43743730688ddf16: ["No"], //TV Yes or no
            _c_6560915e43743730688e084d: ["Yes"], //Computer Yes or no
            // sub categroy
            _c_65771084f23a9b229d7cc53c: [""],
            _c_657710b3f23a9b229d7d07cf: [""],
            _c_657710f2f23a9b229d7d6824: [""],
            _c_65771135f23a9b229d7dd8c0: [window.state.product],
          });
        }

        if (!this.chatBotOpen) {
          this.chatBotOpen = true;
          window.sprChat("updateClientContext", {
            _c_647484e02b41c27ed4ed9a54: ["Yes"], //Key - custom field name, Value - Blank -> skip to agent
          });
          window.sprChat("openNewConversation", {
            initialMessages: [
              {
                message: "Hi, I want to speak to a Samsung Support Expert",
                isSentByUser: true,
              },
            ],
          });
        } else {
          window.sprChat("open");
        }
      });
  }

  showCompiledStep4(compiled, confirmData) {
    var $this = this;
    $this.scrollToWithTime("#repair-request-form", 10);
    $(".thankyou-wrapper.steps.step4").html(compiled);
    if (confirmData.selectedDate == "") {
      $("#date-info-box").hide();
    }
    if (confirmData.deviceDetails.selectedIssue == "") {
      $("#device-issue").hide();
    }

    $(".lds-ring").hide();
    $(".confirm-wrapper.steps").hide();
    $(".thankyou-wrapper.steps.step4").show(1);
  }


  resetCookieValues() {
    var $this = this;

    /** Hide the Step2 and Step3 if it is visible
            Other wise user will keep on come back to repair booking form in the next attempt with out troubleshooter,
            Because session cookies are cleared back end won't ge the lucid reference from the session
        **/
    $("#products-section").hide();
    $("#repair-solutions").hide();
    $("#care-plus-repair").hide();
    window.state.tsoutcome = "";
    window.state.selectedservice = "";
    window.state.productImage = "";
    //$("#repair-solutions").hide();

    $this.contactDetails = new Object();
    $this.deviceDetails = new Object();
    $("#device-details")[0].reset();
    $("#device-fault")[0].reset();
    $("#contact-details")[0].reset();
    if ($("#bespoke-colour-picker").length > 0) {
      $("#bespoke-colour-picker")[0].reset();
    }

    /*this.cookiests.clear('lucidRef');
        this.cookiests.clear('symptomCode1');
        this.cookiests.clear('symptomCode2');
        this.cookiests.clear('symptomCode3');
        this.cookiests.clear('warrantyException');
        this.cookiests.clear('tsRef');*/
  }

  scrollToWithTime(element, time) {
    var stepsSummaryHeight = $(".steps-wrapper").outerHeight() + 20;
    stepsSummaryHeight += $(".floating-navigation").hasClass(
      "floating-navigation--fixed"
    )
      ? 0
      : $(".steps-wrapper").outerHeight();

    stepsSummaryHeight += $(".summary-wrapper").is(":visible")
      ? $(".summary-wrapper").outerHeight()
      : 0;

    var currentPos = $(element).offset().top - stepsSummaryHeight;

    //var currentPos=$(element).offset().top-20;
    setTimeout(function () {
      $("html, body").animate({ scrollTop: currentPos }, 500);
    }, time);
  }

  scrollTo(element) {
    var stepsSummaryHeight = $(".steps-wrapper").outerHeight() + 20;
    stepsSummaryHeight += $(".floating-navigation").hasClass(
      "floating-navigation--fixed"
    )
      ? 0
      : $(".steps-wrapper").outerHeight();

    stepsSummaryHeight += $(".summary-wrapper").is(":visible")
      ? $(".summary-wrapper").outerHeight()
      : 0;

    var currentPos = $(element).offset().top - stepsSummaryHeight;

    //var currentPos=$(element).offset().top-20;
    setTimeout(function () {
      $("html, body").animate({ scrollTop: currentPos }, 500);
    }, 500);
  }

  validate() {
    var $this = this;

    if ($this.step == "step0") {
      var productType = false;
      var serial = false;
      var imeiNumber = false;
      var model = true;

      function isAlphanumeric(value) {
        /*        const regx = new RegExp('^[A-Za-z]{2}[0-9]{2}[A-Za-z0-9/]+$');

                    const regx1 = new RegExp('^[A-Za-z0-9/]+$');

                    console.log(regx.test(model));*/

        const regx = new RegExp("^[A-Za-z0-9/]+$");

        return regx.test(value);
      }

      function isvalidModel(value) {
        const regx = new RegExp("^[A-Za-z0-9-/]+$");

        return regx.test(value);
      }

      function isModel(model) {
        var ModelChrLength = model.length;

        if (
          $this.modelCharLength.indexOf(ModelChrLength) < 0 ||
          !isvalidModel(model)
        ) {
          return false;
        } else {
          return true;
        }
      }

      function isSerial(serial) {
        if (
          serial.length != $this.serialCharLength ||
          !isAlphanumeric(serial)
        ) {
          return false;
        } else {
          return true;
        }
      }

      function isIMEI(s) {
        //console.log('isIMEI - ' + s);

        var etal = /^[0-9]{15}$/;
        if (!etal.test(s)) {
          return false;
        }
        var sum = 0;
        var mul = 2;
        var l = 14;
        for (var i = 0; i < l; i++) {
          var digit = s.substring(l - i - 1, l - i);
          var tp = parseInt(digit, 10) * mul;
          if (tp >= 10) {
            sum += (tp % 10) + 1;
          } else {
            sum += tp;
          }
          if (mul == 1) {
            mul++;
          } else {
            mul--;
          }
        }
        var chk = (10 - (sum % 10)) % 10;
        if (chk != parseInt(s.substring(14, 15), 10)) {
          return false;
        }
        return true;
      }

      $("#product-type")
        .off("change")
        .on("change", function () {
          var mErrorNode = $(this).parent().find(".c-error");

          $("#imei-number").val("");
          $("#serial").val("");
          $("#model").val("");
          /** Reset all variables state before pdlist call **/
          $("#pdlist-error .c-error").text("");
          $this.isRequestToPdListSent = false;

          if ($(this).val() == "") {
            this.style.border = "1px solid #ff001f";
            mErrorNode.text("Product Type is required.");
            productType = false;

            $("#how-do-i-find").hide();
            $("#imei-row").hide();
            $("#serial-row").hide();
            $("#model-row").hide();
          } else {
            this.style.border = "";
            mErrorNode.text("");
            productType = true;

            //console.log("Product type changed");
            if (window.state.product == "Cooking") {
              $this.updateValidationRulesAndPlaceHolders($(this).val());
            }

            $("#how-do-i-find").show();

            if ($(this).val() == "Smartphones") {
              imeiNumber = false;
              serial = true;
              model = true;
              /*if($('#imei-number').val() != "") {
                            $('#imei-number').trigger('blur');
                        }*/
              $("#imei-row").show();
              $("#serial-row").hide();
              $("#model-row").hide();
              $this.isIMEINumberRequired = true;
              $this.isSerialNumberRequired = false;
              $this.isModelNumberRequired = false;

              if (
                window.state.saProductDetail.length &&
                window.state.saProductDetail[0].encImei !== undefined
              ) {
                $("#imei-number").val(window.state.saProductDetail[0].encImei);
                $("#serial").val(
                  window.state.saProductDetail[0].deviceSerialNumberText
                );
                $("#model").val(window.state.saProductDetail[0].deviceModelID);
                $("#model-row").show();
                //$this.isModelNumberRequired = true;
                //$('#imei-number').trigger('input');
                $this.showBtnElement("#pd-info-submit .btn.next");
                setTimeout(function () {
                  //$('#model').css("border","");
                  //$('#model').parent().find('.c-error').text('');
                  $(
                    "#repair-request-form .step0 #pd-info-submit .btn.next"
                  ).trigger("click");
                }, 1000);
              }
            } else {
              imeiNumber = true;
              serial = false;
              model = true;

              /*if($('#serial').val() != "") {
                            $('#serial').trigger('blur');
                        }*/
              $("#imei-row").hide();
              $("#serial-row").show();
              $("#model-row").hide();
              $this.isIMEINumberRequired = false;
              $this.isSerialNumberRequired = true;
              $this.isModelNumberRequired = false;

              if (
                window.state.saProductDetail.length &&
                window.state.saProductDetail[0].deviceSerialNumberText !==
                  undefined
              ) {
                $("#serial").val(
                  window.state.saProductDetail[0].deviceSerialNumberText
                );
                $("#model").val(window.state.saProductDetail[0].deviceModelID);
                $("#model-row").show();
                //$this.isModelNumberRequired = true;
                //$('#serial').trigger('input');
                $this.showBtnElement("#pd-info-submit .btn.next");
                setTimeout(function () {
                  //$('#model').css("border","");
                  //$('#model').parent().find('.c-error').text('');
                  $(
                    "#repair-request-form .step0 #pd-info-submit .btn.next"
                  ).trigger("click");
                }, 1000);
              }
            }
          }

          fieldsFilled();
        });

      $("#serial")
        .off("input  blur")
        .on("input  blur", function () {
          var sErrorNode = $(this).parent().find(".c-error");

          if ($this.isSerialNumberRequired) {
            if (!$this.isRequestToPdListSent) {
              if (this.value == "") {
                this.style.border = "1px solid #ff001f";
                sErrorNode.text("Serial number is required.");
                serial = false;
              } else if (!isSerial($(this).val())) {
                this.style.border = "1px solid #ff001f";
                sErrorNode.text("Serial number entered is not valid.");
                serial = false;
              } else {
                this.style.border = "";
                sErrorNode.text("");
                serial = true;
              }

              fieldsFilled();
            } else {
              this.style.border = "1px solid #ff001f";

              switch ($this.errorCode) {
                case 805:
                  sErrorNode.text(
                    "It appears your product was not purchased in the UK or EU. Please visit the relevant Samsung website where you purchased your product for further assistance."
                  );
                  break;
                case 810:
                  sErrorNode.text(
                    "The Serial number entered is not valid. Please check you have entered the correct serial number e.g. try changing the letter ‘O' to zero ‘0'."
                  );
                  break;
                default:
                  sErrorNode.text("Serial number entered is not valid.");
                  break;
              }

              // sErrorNode.text('Serial number entered is not valid.');
              serial = false;
              $this.isRequestToPdListSent = false;
              fieldsFilled();
            }
          }
        });

      //$('#imei-number').val()

      $("#imei-number")
        .off("input  blur")
        .on("input  blur", function () {
          var iErrorNode = $(this).parent().find(".c-error");

          if ($this.isIMEINumberRequired) {
            if (!$this.isRequestToPdListSent) {
              if (this.value == "") {
                this.style.border = "1px solid #ff001f";
                iErrorNode.text("IMEI number is required.");
                imeiNumber = false;
              } else if (!isIMEI($(this).val())) {
                this.style.border = "1px solid #ff001f";
                iErrorNode.text("IMEI number entered is not valid.");
                imeiNumber = false;
              } else {
                this.style.border = "";
                iErrorNode.text("");
                imeiNumber = true;
              }

              fieldsFilled();
            } else {
              this.style.border = "1px solid #ff001f";

              switch ($this.errorCode) {
                case 804:
                  iErrorNode.text("IMEI number entered is not valid.");
                  // iErrorNode.text('The IMEI number entered is not valid. Please check you have entered the correct imei number.');
                  break;
                case 805:
                  iErrorNode.text(
                    "It appears your product was not purchased in the UK or EU. Please visit the relevant Samsung website where you purchased your product for further assistance."
                  );
                  break;
                default:
                  iErrorNode.text("IMEI number entered is not valid.");
                  break;
              }

              imeiNumber = false;
              $this.isRequestToPdListSent = false;
              fieldsFilled();
            }
          }
        });

      $("#model")
        .off("input  blur")
        .on("input  blur", function () {
          var mErrorNode = $(this).parent().find(".c-error");

          if ($this.isModelNumberRequired) {
            if (!$this.isRequestToPdListSent) {
              model = false;
              $("#model-row .required").show();
              $("#pdlist-error").hide();

              //$('#product-type').trigger('input');
              /*console.log("Model changed");*/
              /*console.log($this.modelCharLength);
		                console.log($this.serialCharLength);*/

              if ($(this).val() == "") {
                this.style.border = "1px solid #ff001f";
                mErrorNode.text("Model is required.");
                model = false;
              } else if (!isModel($(this).val())) {
                this.style.border = "1px solid #ff001f";
                mErrorNode.text("Model entered is not valid.");
                model = false;
              } else {
                this.style.border = "";
                mErrorNode.text("");
                model = true;
              }

              fieldsFilled();
            } else {
              this.style.border = "1px solid #ff001f";

              switch ($this.errorCode) {
                case 805:
                  mErrorNode.text(
                    "It appears your product was not purchased in the UK or EU. Please visit the relevant Samsung website where you purchased your product for further assistance."
                  );
                  break;
                case 808:
                  mErrorNode.text(
                    "The model number entered is not valid. Please check you have entered the correct model number e.g. try changing the letter ‘O' to zero ‘0'."
                  );
                  break;
                default:
                  mErrorNode.text("Model entered is not valid.");
                  break;
              }
              model = false;
              $this.isRequestToPdListSent = false;

              fieldsFilled();
            }
          }
        });

      const fieldsFilled = () => {
        //console.log("ProductType=", productType);

        if (productType && serial && imeiNumber && model) {
          $this.showBtnElement("#pd-info-submit .btn.next");
        } else {
          $this.hideBtnElement("#pd-info-submit .btn.next");
        }
      };
    }

    if ($this.step == "step1") {
      //var productType = ( $('#product-type').val() == "" )? false : true;

      var dateofpurchase = false;
      var placeofpurchase = false;
      var confirmterms = false;

      const popConfirm = () => {
        if (window.state.proofOfPurchase && window.state.proofOfPurchase.file && $('#date-of-purchase--pop').val() == '') {
          return false
        } else {
          return true
        }
      }

      if (window.state.selectedservice == "KISS") {
        $("#date-of-purchase").on("input blur change", function () {
          var sErrorNode = $(this).parent().find(".c-error");

          if (this.value == "") {
            this.style.border = "1px solid #ff001f";
            sErrorNode.text("Date of purchase is required.");
            dateofpurchase = false;
          } else {
            var dateYear = this.value.split("/")[2];

            if ($.trim(dateYear).length != 4) {
              this.style.border = "1px solid #ff001f";
              sErrorNode.text("Please enter a valid date (dd/mm/yyyy)");
              dateofpurchase = false;
            } else {
              this.style.border = "";
              sErrorNode.text("");
              dateofpurchase = true;
            }
          }

          fieldsFilled();
        });

        $("#place-of-purchase")
          .off("input change blur")
          .on("input change blur", function () {
            var mErrorNode = $(this).parent().find(".c-error");

            if ($(this).val() == "") {
              this.style.border = "1px solid #ff001f";
              mErrorNode.text("Place of purchase is required.");
              placeofpurchase = false;
            } else {
              this.style.border = "";
              mErrorNode.text("");
              placeofpurchase = true;
            }

            fieldsFilled();
          });
      } else {
        $("#confirmterms")
          .off("click")
          .on("click", function () {
            var sErrorNode = $(this).parent().find(".c-error");

            if ($(this).prop("checked") == false) {
              this.style.border = "1px solid #ff001f";
              sErrorNode.text(
                "Please tick the box to confirm you acknowledge the terms for repair."
              );
              $("#steps1-disclaimer").hide("slow");
              confirmterms = false;
            } else if ($(this).prop("checked") == true) {
              this.style.border = "";
              sErrorNode.text("");
              confirmterms = popConfirm();
              $("#steps1-disclaimer").slideDown("slow");
              //$this.scrollTo('#steps1-disclaimer');
            }

            fieldsFilled();
          });
      }

      /*        const regx = new RegExp('^[A-Za-z]{2}[0-9]{2}[A-Za-z0-9/]+$');

        const regx1 = new RegExp('^[A-Za-z0-9/]+$');

        console.log(regx.test(model));*/

      const fieldsFilled = () => {
        //console.log("ProductType=", productType);
        if (site == "ie") {
          var validation =
            window.state.selectedservice == "KISS"
              ? dateofpurchase
              : confirmterms;
        }
        //uk page
        else {
          var validation =
            window.state.selectedservice == "KISS"
              ? dateofpurchase && placeofpurchase
              : confirmterms;
        }
        //var  validation = (window.state.selectedservice == "KISS")? dateofpurchase && placeofpurchase : confirmterms;

        //console.log(validation);

        if (window.state.selectedservice == "KISS") {
          if (validation) {
            $this.showBtnElement("#kiss-booking-details .btn.next");
          } else {
            $this.hideBtnElement("#kiss-booking-details .btn.next");
          }
        } else {
          if (validation) {
            $this.showBtnElement("#warranty-details .btn.next");
          } else {
            $this.hideBtnElement("#warranty-details .btn.next");
          }
        }
      };
    }

    if ($this.step == "step2") {
      var productCondition = false;
      var issueNeedToFix = false;

      $("#product-condition")
        .off("input change blur")
        .on("input change blur", function () {
          var mErrorNode = $(this).parent().find(".c-error");

          if ($(this).val() == "") {
            this.style.border = "1px solid #ff001f";
            mErrorNode.text("Product Condition is required.");
            productCondition = false;
          } else {
            this.style.border = "";
            mErrorNode.text("");
            productCondition = true;
          }

          fieldsFilled();
        });

      $("#issue-needs-to-fix")
        .off("input blur")
        .on("input blur", function () {
          var mErrorNode = $(this).parent().find(".c-error")
          var customerIssue = $(this).val();

          // This is for customer not to delete default populated text with lucid ref
          // Old value set to the element at the time populating the default value also when custermer enter the comment
          if (!$this.regexDefaultCustomerComment.test(customerIssue)) {
            $(this).val($(this).attr("oldvalue"));
            $(this).trigger("input");
          } else {
            $("#product-condition").trigger("input");

            if (
              customerIssue == "" ||
              $.trim(customerIssue) == $.trim($this.defaultProductIssue)
            ) {
              //if ( customerIssue == "" ) {

              this.style.border = "1px solid #ff001f";
              mErrorNode.text("Tell us about the issue is required.");
              issueNeedToFix = false;
            } else {
              this.style.border = "";
              mErrorNode.text("");
              issueNeedToFix = true;
            }

            fieldsFilled();
          }
        });

      const fieldsFilled = () => {
        var validation =
          window.state.selectedservice == "BESPOKE"
            ? issueNeedToFix
            : productCondition && issueNeedToFix;

        //console.log(validation);

        if (validation) {
          $("#repair-request-form .step2 .btn.next").removeAttr("disabled");
          $("#repair-request-form .step2 .btn.next").addClass("blue");
        } else {
          $("#repair-request-form .step2 .btn.next").attr("disabled", true);
          $("#repair-request-form .step2 .btn.next").removeClass("blue");
        }
      };
    }

    if ($this.step == "step21") {
      var isSlotsSelected = false;

      $("#device-collection-date")
        .off("input")
        .on("input", function () {
          var deviceCollectionErrorNode = $(this).parent().find(".c-error");

          if ($(this).val() == "") {
            //$(this).parent.style.border = "1px solid #ff001f";
            deviceCollectionErrorNode.text("Please select the collection date");
            isSlotsSelected = false;
          } else {
            this.style.border = "";
            deviceCollectionErrorNode.text("");
            isSlotsSelected = true;
          }

          fieldsFilled();
        });

      // && postcode && addressLine1 && town
      //&& lastName && phone && email
      const fieldsFilled = () => {
        if (isSlotsSelected) {
          $("#repair-request-form .step21 .btn.next").removeAttr("disabled");
          $("#repair-request-form .step21 .btn.next").addClass("blue");
        } else {
          $("#repair-request-form .step21 .btn.next").attr("disabled", true);
          $("#repair-request-form .step21 .btn.next").removeClass("blue");
        }
      };
    }

    if ($this.step == "step21kiss") {
      var isKissSlotsSelected = false;

      $("#selected-appointment-time")
        .off("input")
        .on("input", function () {
          var appointmentDateErrorNode = $(this).parent().find(".c-error");

          if ($(this).val() == "") {
            //$(this).parent.style.border = "1px solid #ff001f";
            appointmentDateErrorNode.text("Please select the appointment time");
            isKissSlotsSelected = false;
          } else {
            this.style.border = "";
            appointmentDateErrorNode.text("");
            isKissSlotsSelected = true;
          }

          fieldsFilled();
        });

      // && postcode && addressLine1 && town
      //&& lastName && phone && email
      const fieldsFilled = () => {
        if (isKissSlotsSelected) {
          $("#repair-request-form .step21kiss .btn.next").removeAttr(
            "disabled"
          );
          $("#repair-request-form .step21kiss .btn.next").addClass("blue");
        } else {
          $("#repair-request-form .step21kiss .btn.next").attr(
            "disabled",
            true
          );
          $("#repair-request-form .step21kiss .btn.next").removeClass("blue");
        }
      };
    }

    if ($this.step == "step21tv") {
      var isTvSlotsSelected = false;

      $("#selected-appointment-time")
        .off("input")
        .on("input", function () {
          var appointmentDateErrorNode = $(this).parent().find(".c-error");

          if ($(this).val() == "") {
            //$(this).parent.style.border = "1px solid #ff001f";
            appointmentDateErrorNode.text("Please select the appointment");
            isTvSlotsSelected = false;
          } else {
            this.style.border = "";
            appointmentDateErrorNode.text("");
            isTvSlotsSelected = true;
          }

          fieldsFilled();
        });

      // && postcode && addressLine1 && town
      //&& lastName && phone && email
      const fieldsFilled = () => {
        if (isTvSlotsSelected) {
          $("#repair-request-form .step21tv .btn.next").removeAttr("disabled");
          $("#repair-request-form .step21tv .btn.next").addClass("blue");
        } else {
          $("#repair-request-form .step21tv .btn.next").attr("disabled", true);
          $("#repair-request-form .step21tv .btn.next").removeClass("blue");
        }
      };
    }

    if ($this.step == "step3") {
      var firstName = false;
      var lastName = false;
      var email = false;
      var confirmemail = false;
      var phone = false;

      //IE change
      if (site == "uk") {
        var postcode = false;
        var town = false;
        var county = true;
      } else if (site == "ie") {
        var postcode = true;
        var town = true;
        var county = false;
      }

      var addressLine1 = false;

      var devicePickupOption =
        window.state.selectedservice != "ISR" ? true : false;

      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      function validateName(name) {
        var re = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g;
        return re.test(String(name));
      }

      $("#firstname")
        .off("input blur")
        .on("input blur", function () {
          var fnErrorNode = $(this).parent().find(".c-error");

          if (
            this.value == "" ||
            this.value.length < 2 ||
            !validateName(this.value)
          ) {
            this.style.border = "1px solid #ff001f";
            if (this.value.length > 0 && this.value.length < 2) {
              fnErrorNode.text(
                "The First Name field must be at least 2 characters."
              );
            } else {
              fnErrorNode.text("The First Name field is required.");
            }
            firstName = false;
          } else {
            this.style.border = "";
            fnErrorNode.text("");
            firstName = true;
          }

          fieldsFilled();
        });

      $("#lastname")
        .off("input blur")
        .on("input blur", function () {
          var lnErrorNode = $(this).parent().find(".c-error");

          if (this.value == "" || !validateName(this.value)) {
            this.style.border = "1px solid #ff001f";
            lnErrorNode.text("The Last Name field is required.");
            lastName = false;
          } else {
            this.style.border = "";
            lnErrorNode.text("");
            lastName = true;
          }

          fieldsFilled();
        });

      $("#email")
        .off("input blur")
        .on("input blur", function () {
          var emailErrorNode = $(this).parent().find(".c-error");
          var confirmemail = $("#confirmemail").val();

          if (this.value == "") {
            this.style.border = "1px solid #ff001f";
            emailErrorNode.text("The Email field is required.");
            email = false;
          } else if (!validateEmail(this.value)) {
            this.style.border = "1px solid #ff001f";
            emailErrorNode.text("The Email field must be a valid email.");
            email = false;
          } else if (confirmemail != "" && this.value != confirmemail) {
            this.style.border = "1px solid #ff001f";
            emailErrorNode.text(
              "The Email and Confirm Email fields must be same."
            );
            email = false;
          } else {
            this.style.border = "";
            emailErrorNode.text("");
            email = true;
          }

          fieldsFilled();
        });

      $("#confirmemail")
        .off("input blur")
        .on("input blur", function () {
          var emailErrorNode = $(this).parent().find(".c-error");

          var email = $("#email").val();

          if (this.value == "") {
            this.style.border = "1px solid #ff001f";
            emailErrorNode.text("The Confirm Email field is required.");
            confirmemail = false;
          } else if (!validateEmail(this.value)) {
            this.style.border = "1px solid #ff001f";
            emailErrorNode.text(
              "The Confirm Email field must be a valid email."
            );
            confirmemail = false;
          } else if (this.value != email) {
            this.style.border = "1px solid #ff001f";
            emailErrorNode.text(
              "The Email and Confirm Email fields must be same."
            );
            confirmemail = false;
          } else {
            this.style.border = "";
            emailErrorNode.text("");
            confirmemail = true;
          }

          fieldsFilled();
        });

      $("#phonenumber")
        .off("input blur")
        .on("input blur", function () {
          var phoneErrorNode = $(this).parent().find(".c-error");

          var reqExp = "";

          if (site == "uk") {
            reqExp = RegExp("^[0-9]{11}$");
          } else if (site == "ie") {
            reqExp = RegExp("^[0-9]{10}$");
          }

          if (this.value == "") {
            this.style.border = "1px solid #ff001f";
            phoneErrorNode.text("The Phone Number field is required.");
            phone = false;

            //} else if (!(RegExp('^0[0-9]{11}$|').test(this.value))) {
          } else if (
            !reqExp.test(this.value) ||
            !RegExp("^0[0-9]{9,10}$").test(this.value)
          ) {
            this.style.border = "1px solid #ff001f";
            phoneErrorNode.text("The Phone Number field format is invalid.");
            phone = false;
          } else {
            this.style.border = "";
            phoneErrorNode.text("");
            phone = true;
          }

          fieldsFilled();
        });

      $("#postcode")
        .off("input blur change")
        .on("input blur change", function () {
          var postcodeErrorNode = $(this).parent().find(".c-error");

          var postcodeValue = $.trim(this.value);

          if ($this.postcodeSearch == false) {
            $this.validatePostcode(postcodeValue);
          }

          if (
            postcodeValue == "" ||
            postcodeValue.length < 5 ||
            !$this.isValidPostCode
          ) {
            this.style.border = "1px solid #ff001f";
            $("#postcodesearch").css("border", "1px solid #ff001f");
            postcodeErrorNode.text("Please enter a valid postcode.");
            postcode = false;
            //$('.contact-details .autocomplete-items').remove();
          } else {
            if ($this.isValidPostCode) {
              this.style.border = "";
              $("#postcodesearch").css("border", "");
              postcodeErrorNode.text("");
              postcode = true;
            } else {
              $this.validatePostcode(postcodeValue);
            }

            //$this.doGeoCode(postcodeValue);
            // $('#response1').html("Please enter a post code");
          }

          fieldsFilled();
        });

      $("#address1")
        .off("input blur")
        .on("input blur", function () {
          var add1ErrorNode = $(this).parent().find(".c-error");

          if (this.value == "") {
            this.style.border = "1px solid #ff001f";
            add1ErrorNode.text("Address line 1 field is required.");
            addressLine1 = false;
          } else {
            this.style.border = "";
            add1ErrorNode.text("");
            addressLine1 = true;
          }

          fieldsFilled();
        });

      $("#town")
        .off("input blur")
        .on("input blur", function () {
          var tErrorNode = $(this).parent().find(".c-error");

          if (this.value == "") {
            this.style.border = "1px solid #ff001f";
            tErrorNode.text("City field is required.");
            town = false;
          } else {
            this.style.border = "";
            tErrorNode.text("");
            town = true;
          }

          fieldsFilled();
        });

      //IE change
      $("#county").on("input blur", function () {
        var tErrorNode = $(this).parent().find(".c-error");

        if (this.value == "") {
          this.style.border = "1px solid #ff001f";
          tErrorNode.text("County field is required.");
          county = false;
        } else {
          this.style.border = "";
          tErrorNode.text("");
          county = true;
        }

        fieldsFilled();
      });

      $("#device-pickup-option")
        .off("input")
        .on("input", function () {
          var dpoErrorNode = $(this).parent().find(".c-error");

          if ($(this).val() == "") {
            $(this).parent.style.border = "1px solid #ff001f";
            dpoErrorNode.text("Device Pickup option is required.");
            devicePickupOption = false;
          } else {
            this.style.border = "";
            dpoErrorNode.text("");
            devicePickupOption = true;
          }

          fieldsFilled();
        });

      // && postcode && addressLine1 && town
      //&& lastName && phone && email
      const fieldsFilled = () => {
        if (
          firstName &&
          lastName &&
          phone &&
          email &&
          confirmemail &&
          postcode &&
          addressLine1 &&
          town &&
          county &&
          devicePickupOption
        ) {
          $("#contact-details .btn.next").removeAttr("disabled");
          $("#repair-request-form .step3 .btn.next").addClass("blue");
        } else {
          $("#contact-details .btn.next").attr("disabled", true);
          $("#repair-request-form .step3 .btn.next").removeClass("blue");
        }
      };
    }
  }

  validatePostcode(postcode) {
    var $this = this;

    const regx =
      /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/;

    $this.doLog("entered postcode " + postcode);

    var isValidPostcode = regx.test(postcode);

    $this.doLog("isvalidpostcode" + isValidPostcode);

    if (regx.test(postcode)) {
      $(".contact-details #postcode").val(postcode);

      $this.validatedPostCode = postcode;
      $this.isValidPostCode = true;

      // Search address list only user choosed the option postcode search
      if ($this.postcodeSearch) {
        // show loader for address search
        $(".lds-ring").show();
        $(".contact-details .autocomplete-items").remove();
        $("#postcode").trigger("input");
        $this.getAddress(postcode);
      }
    } else {
      $this.validatedPostCode = postcode;
      $this.isValidPostCode = false;

      if ($this.postcodeSearch) {
        if ($(".contact-details .autocomplete-items").length > 0) {
          $(".contact-details .autocomplete-items").remove();
        }

        $("#postcode").trigger("input");
      }
    }
  }

  getAddress(postcode) {
    var $this = this;

    var url = $this.host + $this.path + "find-address/";

    var form = new FormData();

    $this.doLog("do geocode postcode " + postcode);

    // form.append("postcode", "w60ug");
    form.append("search_text", postcode);
    form.append("type", "Address");

    $this.doLog("post code", postcode);

    var settings = {
      url: url,
      data: form,
      processData: false,
      contentType: false,
      type: "POST",
    };

    $.ajax(settings).done(function (response) {
      // console.log(response);
      // console.log(response);
      var theHtml = "";
      if (response.Items && response.Items.length > 0) {
        theHtml +=
          '<div id="postcodeautocomplete-list" class="autocomplete-items">';
        for (var i = 0; i < response.Items.length; i++) {
          var item = response.Items[i];
          theHtml +=
            '<div class="saddress" data-id="' +
            item.Id +
            '">' +
            item.Text +
            ", " +
            item.Description +
            "</div>";
          //theHtml += '<option value="'+item.Id+'">' + item.Text + ', ' + item.Description + '</option>';
        }

        theHtml += "</div>";
      }

      //$('#response2').html(theHtml);
      $(".contact-details .autocomplete-items").remove();
      $(".contact-details .autocomplete").append(theHtml);
      // $('#postcodesearch').removeAttr("disabled");
      $(".lds-ring").hide();

      $("#postcodeautocomplete-list .saddress")
        .off("click")
        .on("click", function () {
          var dataId = $(this).attr("data-id");

          if (dataId != "") {
            $this.getAddressDetail(dataId);
          } else {
            $this.doLog("No address Id associated with the address");
          }
        });

      $(".contact-details #postcode").val(postcode);

      // If the response come back with false then show 'Invalid postcode' error to user
      if (!response.success) {
        $this.isValidPostCode = false;
        $("#postcode").trigger("input");
      }
    });
  }

  getAddressDetail(id) {
    var $this = this;

    var url = $this.host + $this.path + "retrieve-address/";

    var form = new FormData();

    $this.doLog("selected Id " + id);

    // form.append("postcode", "w60ug");
    form.append("address-id", id);

    var settings = {
      url: url,
      data: form,
      processData: false,
      contentType: false,
      type: "POST",
    };

    // should use handlebars template

    $.ajax(settings).done(function (response) {
      $(".contact-details .autocomplete-items").remove();
      $(".contact-details #postcode").val(response.postal_code);
      $(".contact-details #postcodesearch").val(response.postal_code);
      $(".contact-details #address1").val(response.line_1);

      var addressLine2 = response.line_2;
      var addressLine3 = response.landmark;
      // Back end only accepts 40 chars for address lines
      if (addressLine2.length > 40) {
        var addLine2substr = addressLine2.substring(0, 40);
        var lastIndex = addLine2substr.lastIndexOf(",");
        if (lastIndex > 0) {
          var addLine2 = addressLine2.substring(0, lastIndex);
          var addLine3 = addressLine2.substring(lastIndex + 1);
        } else {
          lastIndex = addLine2substr.lastIndexOf(" ");
          if (lastIndex > 0) {
            var addLine2 = addressLine2.substring(0, lastIndex);
            var addLine3 = addressLine2.substring(lastIndex + 1);
          }
        }

        addressLine2 = addLine2;
        addressLine3 = addLine3;
      }

      $(".contact-details #address2").val(addressLine2);
      $(".contact-details #address3").val(addressLine3);

      $(".contact-details #town").val(response.city);
      //$('.contact-details #country').val(response.country);

      /** Triggert the validation of required elements **/
      $("#postcode").trigger("input");
      $("#address1").trigger("input");
      $("#town").trigger("input");
      //$("#country").trigger('input');
    });
  }
}
